import { Action, action, thunk, Thunk } from 'easy-peasy';
import { fetchProductCode, fetchProductData, fetchCountryRegion } from '@pfp';
import OktaSignIn from '@okta/okta-signin-widget';
import OktaConfig from '../../OktaConfig';

import {
  ROLE_PROFESSIONAL,
  ROLE_DISTRIBUTOR,
  ROLE_OTHER,
  ROLE_CAREGIVER,
} from '@constants';
export interface FormModel {
  showError: boolean;
  acceptedTerms: boolean;
  acceptedTermsTheTransfer: boolean;
  recaptchaToken?: string;
  role?: string;
  source?: string;
  emailAddress?: string;
  additionalContactEmail?: string;
  careGiverEmail?: string;
  patientEmail?: string;
  reporterEmail?: string;
  employeeEmail?: string;
  otherEmail?: string;
  reportedTo?: string;
  referenceNumber?: string;
  accountNumber?: string;
  notificationDate?: string;
  eventDate?: string;
  processStep?: string;
  wasPatientUsingProduct?: string;
  additionalInformation?: string;
  reportedByAnotherFacility?: string;
  lotNo?: string;
  productName?: string;
  productCode?: string;
  ndcNo?: string;
  udiNo?: string;
  selectedQuantity?: string;
  unit?: string;
  reportedProblem?: string;
  isTheActualProductWithReportedProblemAvailableForReturn?: string;
  howManySamplesReturningForInvestigation?: string;
  isPhotoOrVideoAvailable?: string;
  isOneUnusedBaxterProductAvailableForReturn?: string;
  selfImpactExperienced?: string;
  patientImpactExperienced?: string;
  counteractionProvided?: string;
  requiredTreatment?: string;
  relevantTests?: string;
  medicalHistory?: string;
  patientName?: string;
  patientAge?: string;
  patientSex?: string;
  patientGender?: string;
  patientGenderError?: boolean;
  otherPatientGender?: string;
  patientWeight?: string;
  patientWeightUnit?: string;
  drugUsedDuringEvent?: string;
  nameOfBaxterDrug?: string;
  reporterOccupation?: string;
  typeOfDamage?: string;
  followingOccur?: string;
  damageMinicap?: string;
  excessiveForce?: string;
  transfer?: string;
  twistClamp?: string;
  difficultToUse?: string;
  difficultiesMinicap?: string;
  describeIssue?: string;
  flowIssue?: string;
  blockingFlow?: string;
  environment?: string;
  spongeVisibleMinicap?: string;
  materialLocated?: string;
  materialLocatedOther?: string;
  materialDetails?: string;
  materialEmbedded?: string;
  componentAppear?: string;
  disposableConnection?: string;
  initialConnection?: string;
  spikeLuerConnectors?: string;
  petsOrAnimals?: string;
  spikeLuerDifficulties?: string;
  minicapTwisted?: string;
  transferSet?: string;
  residueThreads?: string;
  whatAlarm?: string;
  residueThreadsOther?: string;
  difficultiesMinicapOther?: string;
  difficultToUseOther?: string;
  blockingFlowOther?: string;
  observedDamage?: string;
  observedDamageOther?: string;
  typeObservedDamage?: string;
  damageCauseLeak?: string;
  shippingCartonOpen?: string;
  flowIssueObserved?: string;
  expiredProductFound?: string;
  adapterDevice?: string;
  nameModelAdapter?: string;
  nameModelVaporizer?: string;
  squeezingSolution?: string;
  productInformationVial?: string;
  forthMotion?: string;
  alarmNoFlow?: string;
  productDiscolored?: string;
  productDiscoloredOther?: string;
  discoloration?: string;
  discolorationMarkings?: string;
  chamberDiscolored?: string;
  brokenActivated?: string;
  vaporizerSightGlass?: string;
  specificallyDescribes?: string;
  specificallyDescribesOther?: string;
  specificallyDescribesAlarm?: string;
  specificallyDeviceAlarm?: string;
  componentMisassembled?: string;
  reconstitutionIssue?: string;
  volumeMedication?: string;
  devicesReconstitution?: string;
  productHeat?: string;
  exposureTemperature?: string;
  activateSolution?: string;
  damagePriorActivation?: string;
  describeDamagePrior?: string;
  powderFilled?: string;
  leakObserved?: string;
  productDifficult?: string;
  howProductDifficult?: string;
  matterForeignMaterial?: string;
  matterForeignMaterialPieces?: string;
  matterForeignMaterialOther?: string;
  matterForeignMaterialPiecesOther?: string;
  exactTypeMaterial?: string;
  embeddedInTheProduct?: string;
  whenMaterialObserved?: string;
  medicationAdded?: string;
  reconstitutionTechnique?: string;
  reconstitutionDevice?: string;
  wasSolutionAddedProduct?: string;
  whatSolutionAddedProduct?: string;
  cloudinessObserved?: string;
  cloudinessGoAway?: string;
  agitateUnit?: string;
  precipitateDissolve?: string;
  productStorageTemperature?: string;
  temperatureLogsFreezer?: string;
  storageUnitCalibrated?: string;
  productThawed?: string;
  productThawedOther?: string;
  conditionsProduct?: string;
  damageIssueObserved?: string;
  damageIssueObservedOther?: string;
  damageSpecificInfo?: string;
  damageSpecificInfoOther?: string;
  purposeIndication?: string;
  routeAdministration?: string;
  administrationDuration?: string;
  dosageStrength?: string;
  recentPrescription?: string;
  storageTemperatureDetails?: string;
  additivesPrior?: string;
  appropriateDescription?: string;
  appropriateDescriptionOther?: string;
  labelingIssue?: string;
  labelingIssueOther?: string;
  expiredProduct?: string;
  abnormalitiesDamage?: string;
  purchaseOrderNumber?: string;
  dateAdministration?: string;
  expirationDateProduct?: string;
  describeIncorrect?: string;
  scannerUsed?: string;
  overpouchPouchScanning?: string;
  backgroundColorScanning?: string;
  labelsSameInformation?: string;
  barcodeScanner?: string;
  productsStoredFacility?: string;
  whatIncorrectlyDisplayed?: string;
  whatIncorrectlyDisplayedOther?: string;
  moistureObserved?: string;
  moistureObservedOther?: string;
  componentLeaking?: string;
  componentLeakingOther?: string;
  frangibleBroken?: string;
  moistureClear?: string;
  moistureClearOther?: string;
  yourDistributor?: string;
  vialUsed?: string;
  sitePunctured?: string;
  administrationSetUsed?: string;
  difficultySpiking?: string;
  scenariosWithLeak?: string;
  wasFrangibleDamage?: string;
  pressureAmount?: string;
  pressureCuff?: string;
  sizePressureCuff?: string;
  leakBeingDetected?: string;
  vaporizerNameModel?: string;
  liquidSpilled?: string;
  bottleIntoVaporizer?: string;
  visibleDefects?: string;
  optionConnectionIssue?: string;
  productSeparated?: string;
  whatComponentDiscolored?: string;
  whatComponentDiscoloredOther?: string;
  describesDiscoloration?: string;
  describesDiscolorationOther?: string;
  removedFromPackage?: string;
  addingMedication?: string;
  whatMedicationColor?: string;
  whereMatterLocated?: string;
  whereMatterTypes?: string;
  embeddedPlastic?: string;
  infusateSolution?: string;
  infusateSolutionOther?: string;
  medicationsSolutions?: string;
  damageComponentAffected?: string;
  damageComponentAffectedOther?: string;
  whatTypeDamageIssue?: string;
  whatTypeDamageIssueOther?: string;
  patientConnectedProduct?: string;
  wasProductReplaced?: string;
  situationDescribesIssue?: string;
  situationDescribesIssueOther?: string;
  descriptionLabelingIssue?: string;
  descriptionLabelingIssueOther?: string;
  whatInfoDisplayed?: string;
  typeScannerUsed?: string;
  appropriateDescIssueOther?: string;
  whatPurchaseOrderNumber?: string;
  whoDistributor?: string;
  expirationDatePproduct?: string;
  leakComingFrom?: string;
  leakComingFromOther?: string;
  followingScenarios?: string;
  followingScenariosOther?: string;
  wasPowerInjector?: string;
  whatPowerInjector?: string;
  missingTypeInLabel?: string;
  secondProductInvolved?: string;
  crackBreak?: string;
  cutHoleSlice?: string;
  injectionSiteOpening?: string;
  injectionSiteOpeningOther?: string;
  productInfoDisconnection?: string;
  bondedComponents?: string;
  visibleIrregularities?: string;
  eventuallyEstablished?: string;
  toolUsedAssist?: string;
  securePriorUse?: string;
  priorDisconnecting?: string;
  situationFlowIssue?: string;
  flowingBackwards?: string;
  backflowStopped?: string;
  situationsApplyEvent?: string;
  areaFlowIssues?: string;
  flowPreviouslySeen?: string;
  previouslyFlowObserved?: string;
  simultaneousFlow?: string;
  hangerUsed?: string;
  hangerLength?: string;
  bagLower?: string;
  ySiteConnected?: string;
  solutionBlood?: string;
  componentSetReplaced?: string;
  volumeFluidToThePatient?: string;
  whatFluidInThePatient?: string;
  withPump?: string;
  clampFail?: string;
  whatClampFailed?: string;
  issuesObservedClamp?: string;
  otherSituationsProduct?: string;
  alarmObserved?: string;
  deviceAlarm?: string;
  whichClampIssue?: string;
  clampIssueExperienced?: string;
  clampDescribesIssue?: string;
  clampProductDifficult?: string;
  difficultFollowUnderstand?: string;
  smellComingFrom?: string;
  clampIssueSet?: string;
  whereProductLeak?: string;
  leakOccur?: string;
  whichBondedComponents?: string;
  leakScenarios?: string;
  productDamaged?: string;
  leakObservedDamage?: string;
  whoIsDistributor?: string;
  whatComponentProdDiscolored?: string;
  descColorObserved?: string;
  howProductStored?: string;
  matterForeignLocated?: string;
  selOptionConnectionIssue?: string;
  whereIssueOccur?: string;
  visibleIrregularitiesObserved?: string;
  optionFlowIssue?: string;
  howProductSetup?: string;
  whatWasSimilar?: string;
  descOfIssue?: string;
  shippingCartonDamaged?: string;
  prodSupposedReceived?: string;
  gelPacks?: string;
  missingUnits?: string;
  expiredProductUse?: string;
  expirationDateProd?: string;
  expiredProductWasFound?: string;
  cleaningSolutions?: string;
  disinfectantNameBrand?: string;
  difficultInTwistClamp?: string;
  componentHadIssue?: string;
  damageCutHoleCrack?: string;
  transferReplaced?: string;
  selectComponentHadIssue?: string;
  fullyTightened?: string;
  anyComponentDamaged?: string;
  issueResultLeak?: string;
  carrierDelivered?: string;
  contactInformationForaddtionalQuestionsAboutReport?: string;
  investigationResults?: string;
  orderFromBaxter?: string;
  quantityCredit?: string;
  wholesalerName?: string;
  reporterFacility?: string;
  reporterAddress1?: string;
  reporterAddress2?: string;
  reporterCity?: string;
  reporterState?: string;
  reporterPostalCode?: string;
  reporterCountry?: string;
  reporterPhone?: string;
  employeeName?: string;
  employeePhone?: string;
  AreYouAbleToBringAvailableSampleToYourHealthcareProviderForEvaluation?: string;
  addAnotherFacility?: string;
  occupation?: string;
  phoneNumber?: string;
  facility?: string;
  alarm?: string;
  imageOverlay?: string;
  explicitlyRequest?: string;
  werePatientUsingProduct?: string;
  moreProductItem?: any;
  productCodeOptions?: any;
  nameNotified?: string;
  editIndex?: number;
  facilityAddress1?: string;
  facilityAddress2?: string;
  facilityCity?: string;
  facilityState?: string;
  facilityPostalCode?: string;
  facilityCountry?: string;
  additionalContactPhone?: string;
  anotherFacilityHospital?: string;
  anotherFacilityAddress1?: string;
  anotherFacilityAddress2?: string;
  anotherFacilityCity?: string;
  anotherFacilityState?: string;
  anotherFacilityPostalCode?: string;
  anotherFacilityCountry?: string;
  moreShowProductArea?: boolean;
  sameAsAddress1?: string;
  sameAsAddress2?: string;
  sameAsCity?: string;
  sameAsState?: string;
  sameAsPostalCode?: string;
  sameAsCountry?: string;
  uploadImage?: any;
  attachment?: any;
  reporterErr?: boolean;
  productattachment?: any;
  sameAsPhoneNumber?: any;
  selectedCountry?: string;
  selectedProductCode?: string;
  productFamily?: any;
  productType?: any;
  errorProductCode?: boolean;
  errorLotNo?: boolean;
  searchingLotNo?: boolean;
  searchingProductCode?: boolean;
  piecesMaterial?: string;
  solutionOrderedFromBaxter?: string;
  region?: string;
  showPrivacy?: boolean;
  provideDetails?: string;
  myName?: string;
  myPhoneNumber?: string;
  patientPhoneNumber?: string;
  patientIdentifier?: string;
  patientAddress_1?: string;
  patientAddress_2?: string;
  patientCity?: string;
  patientState?: string;
  patientPostalCode?: string;
  patientCountry?: string;
  myAddress_1?: string;
  myAddress_2?: string;
  myCity?: string;
  myState?: string;
  myPostalCode?: string;
  myCountry?: string;
  doesTheParticulate?: string;
  pdRenalSelectTheComponent?: string;
  shippingDistributionLabelProductCode?: string;
  shippingDistributionLabelProductLot?: string;
  cartonLabelProductCode?: string;
  cartonLabelProductLot?: string;
  internalProductLabelLot?: string;
  aopDescriptionLabelingIssue?: string;
  internalProductLabelCode?: string;
  aopOptionConnectionIssue?: string;
  lemCleaningSolutions?: string;
  lemDisinfectantNameBrand?: string;
  lemExcessiveForce?: string;
  lemtransferReplaced?: string;
  lemFollowingOccur?: string;
  dtuTransfer?: string;
  lemTransfer?: string;
  scTransfer?: string;
  lemTwistClamp?: string;
  lemDifficultInTwistClamp?: string;
  liAppropriateDescription?: string;
  fiSpecificallyDescribes?: string;
  siepLabelingIssue?: string;
  liExpiredProduct?: string;
  othAbnormalitiesDamage?: string;
  liExpirationDateProduct?: string;
  othMedicationsSolutions?: string;
  siepAopDescriptionLabelingIssue?: string;
  scFollowingScenarios?: string;
  scBondedComponents?: string;
  fiVisibleIrregularitiesObserved?: string;
  damDescOfIssue?: string;
  scWasPowerInjector?: string;
  damWasPowerInjector?: string;
  disHowProductStored?: string;
  aopMaterialDetails?: string;
  sameAsMyAddressCheck?: string;
  sameAsPatientAddressCheck?: string;
  siexAccessOrderedFromBaxter?: string;
  liOrderedFromBaxter?: string;
  pdrComponentHadIssue?: string;
  tsetLemtransferReplaced?: string;
  aopPurchaseOrderNumber?: string;
  aopSolutionOrderedFromBaxter?: string;
  errorOnNext?: boolean;
  patientDob?: string;
  scIssueResultLeak?: string;
  lemAnyComponentDamaged?: string;
  lemComponentHadIssue?: string;
  dtuCleaningSolutions?: string;
  scCleaningSolutions?: string;
  accAppropriateDescIssue?: string;
  accSolutionOrderedFromBaxter?: string;
  damComponentHadIssue?: string;
  solutionFlowIssueobservedDamage?: string;
  solutionFlowIssueTypeObservedDamage?: string;
  solutionFlowIssueDamageCauseLeak?: string;
  solutionOtherobservedDamage?: string;
  solutionOtherTypeObservedDamage?: string;
  solutionOtherDamageCauseLeak?: string;
  siepLeakObservedDamage?: string;
  errorForUncompleteForm?: boolean;
  acSpecificallyDeviceAlarm?: string;
  siepYourDistributor?: string;
  solPurchaseOrderNumber?: string;
  scDisinfectantNameBrand?: string;
  dtuDisinfectantNameBrand?: string;
  aopMaterialLocated?: string;
  scPdrDamageCutHoleCrack?: string;
  scFullyTightened?: string;
  scProductInfoDisconnection?: string;
  lemProductInfoDisconnection?: string;
  scAccessProductInfoDisconnection?: string;
  siepCarrierDelivered?: string;
  aopExpiredProductFound?: string;
  submitApiResponse?: any;
  doeError?: boolean;
  updatedEventDate?: string;
  hardware?: string;
  samePatientAddress_1?: string;
  samePatientAddress_2?: string;
  samePatientCity?: string;
  samePatientState?: string;
  samePatientPostalCode?: string;
  samePatientCountry?: string;
  otherLemComponentHadIssue?: string;
  otherDamComponentHadIssue?: string;
  otherSelectComponentHadIssue?: string;
  otherPdrComponentHadIssue?: string;
  otherComponentHadIssue?: string;
  otherDifficultToUse?: string;
  otherDifficultiesMinicap?: string;
  otherBlockingFlow?: string;
  otherDescribeIssue?: string;
  otherMaterialLocated?: string;
  otherObservedDamage?: string;
  otherTypeObservedDamage?: string;
  otherAppropriateDescription?: string;
  otherLiAppropriateDescription?: string;
  otherProductDiscolored?: string;
  otherSpecificallyDescribes?: string;
  otherMatterForeignMaterial?: string;
  otherMatterForeignMaterialPieces?: string;
  otherDamageIssueObserved?: string;
  otherProductThawed?: string;
  otherDamageSpecificInfo?: string;
  otherLabelingIssue?: string;
  otherWhatIncorrectlyDisplayed?: string;
  otherMoistureObserved?: string;
  otherComponentLeaking?: string;
  otherDamageComponentAffected?: string;
  otherWhatTypeDamageIssue?: string;
  otherIssueResultLeak?: string;
  otherSituationDescribesIssue?: string;
  otherDescriptionLabelingIssue?: string;
  otherAopDescriptionLabelingIssue?: string;
  otherSiepAopDescriptionLabelingIssue?: string;
  otherAccAppropriateDescIssue?: string;
  otherLeakComingFrom?: string;
  otherFollowingScenarios?: string;
  otherInjectionSiteOpening?: string;
  otherScIssueResultLeak?: string;
  otherSituationFlowIssue?: string;
  otherSituationsApplyEvent?: string;
  otherSimultaneousFlow?: string;
  otherWhatClampFailed?: string;
  otherIssuesObservedClamp?: string;
  otherOtherSituationsProduct?: string;
  otherWhichClampIssue?: string;
  otherClampIssueExperienced?: string;
  otherClampDescribesIssue?: string;
  otherLeakOccur?: string;
  otherProductDamaged?: string;
  otherOptionFlowIssue?: string;
  otherDescOfIssue?: string;
  otherDamDescOfIssue?: string;
  otherResidueThreads?: string;
  otherAnyComponentDamaged?: string;
  otherMoistureClear?: string;
  otherInfusateSolution?: string;
  drugsAndBiologics?: any;
  scDamageCutHoleCrack?: string;
  otherSolutionFlowIssueobservedDamage?: string;
  otherSolutionOtherobservedDamage?: string;
  otherSolutionOtherTypeObservedDamage?: string;
  otherSolutionFlowIssueTypeObservedDamage?: string;
  lotResetFlag?: boolean;
  pcodeResetFlag?: boolean;
  ndcResetFlag?: boolean;
  udcResetFlag?: boolean;
  pnameResetFlag?: boolean;
  acWhatAlarm?: string;
  intakeFieldResetFlag?: boolean;
  otherFiSpecificallyDescribes?: string;
  otherSiepLabelingIssue?: string;
  otherScFollowingScenarios?: string;
  otherVisibleIrregularities?: string;
  otherAlarm?: string;
  otherToolUsedAssist?: string;
  otherDescribesDiscoloration?: string;
  otherWhatComponentDiscolored?: string;
  otherWithPump?: string;
  redirectPatientPhoneNumber?: string;
  redirectPatientPhoneNumberFlag?: boolean;
  redirectPatientEmail?: string;
  redirectPatientEmailFlag?: boolean;
  redirectPatientAge?: string;
  redirectedFromPortalFlag?: boolean;
  redirectAccountNumber?: string;
  yourFirstName?: string;
  yourLastName?: string;
  myFirstName?: string;
  myLastName?: string;
  patientFirstName?: string;
  patientLastName?: string;
  reporterFirstName?: string;
  reporterLastName?: string;
  employeeFirstName?: string;
  employeeLastName?: string;
  endUserCostomerContactFirstName?: string;
  endUserCostomerContactLastName?: string;
  additionalContactFirstName?: string;
  additionalContactLastName?: string;
  pqFieldResetFlag?: boolean;
  productCodeResetFlag?: boolean;
  whatMedicationSolution?: string;
  addAdditionalContact?: boolean;
  customerDoesNotWish?: boolean;
  myAddressDoNotContact?: boolean;
  facilityAddressDoNotContact?: boolean;
  endUserCustomerFacilityName?: string;
  endUserCustomerFacilityPhone?: string;
  endUserCustomerEmail?: string;
  endUserCustomerFacilityAddress1?: string;
  endUserCustomerFacilityAddress2?: string;
  endUserCustomerFacilityCity?: string;
  endUserCustomerFacilityState?: string;
  endUserCustomerFacilityPostalCode?: string;
  endUserCustomerFacilityCountry?: string;
  patientAddressDoNotContact?: boolean;
  myAddressSameAsPatientAddressCheck?: string;
  returnKitAddressSameAsMyAddress?: string;
  returnKitAddressSameAsReporterAddress?: string;
  returnKitAddressSameAsPatientAddress?: string;
  returnKitAddressSameAsEndUserCustomerAddress?: string;
  redirectedFromB2bPortal?: boolean;
  uncompleteAddressInProduct?: number;
  isReturnKitAddressAdded?: boolean;
  setShowError: Action<FormModel, boolean>;
  setAcceptedTerms: Action<FormModel, boolean>;
  setRecaptchaToken: Action<FormModel, string>;
  setRole: Action<FormModel, string>;
  setSource: Action<FormModel, string>;
  setEmailAddress: Action<FormModel, string>;
  setAdditionalContactEmail: Action<FormModel, string>;
  setCareGiverEmail: Action<FormModel, string>;
  setPatientEmail: Action<FormModel, string>;
  setReporterEmail: Action<FormModel, string>;
  setEmployeeEmail: Action<FormModel, string>;
  setOtherEmail: Action<FormModel, string>;
  setReportedTo: Action<FormModel, string>;
  setReferenceNumber: Action<FormModel, string>;
  setAccountNumber: Action<FormModel, string>;
  setNotificationDate: Action<FormModel, string>;
  setEventDate: Action<FormModel, string>;
  setProcessStep: Action<FormModel, string>;
  setWasPatientUsingProduct: Action<FormModel, string>;
  setAdditionalInformation: Action<FormModel, string>;
  setReportedByAnotherFacility: Action<FormModel, string>;
  setLotNo: Action<FormModel, string>;
  setProductName: Action<FormModel, string>;
  setProductCode: Action<FormModel, string>;
  setNdcNo: Action<FormModel, string>;
  setUdiNo: Action<FormModel, string>;
  setSelectedQuantity: Action<FormModel, string>;
  setUnit: Action<FormModel, string>;
  setProblem: Action<FormModel, string>;
  setIsProductAvailableForReturn: Action<FormModel, string>;
  setReturnQuantity: Action<FormModel, string>;
  setIsPhotoAvailable: Action<FormModel, string>;
  setIsAvailableForReturn: Action<FormModel, string>;
  setSelfImpactExperienced: Action<FormModel, string>;
  setPatientImpactExperienced: Action<FormModel, string>;
  setCounteractionProvided: Action<FormModel, string>;
  setRequiredTreatment: Action<FormModel, string>;
  setRelevantTests: Action<FormModel, string>;
  setMedicalHistory: Action<FormModel, string>;
  setPatientName: Action<FormModel, string>;
  setPatientAge: Action<FormModel, string>;
  setPatientSex: Action<FormModel, string>;
  setPatientGender: Action<FormModel, string>;
  setPatientGenderError: Action<FormModel, boolean>;
  setOtherPatientGender: Action<FormModel, string>;
  setPatientWeight: Action<FormModel, string>;
  setPatientWeightUnit: Action<FormModel, string>;
  setDrugUsedDuringEvent: Action<FormModel, string>;
  setNameOfBaxterDrug: Action<FormModel, string>;
  setReporterOccupation: Action<FormModel, string>;
  setTypeOfDamage: Action<FormModel, string>;
  setFollowingOccur: Action<FormModel, string>;
  setDamageMinicap: Action<FormModel, string>;
  setExcessiveForce: Action<FormModel, string>;
  setTransfer: Action<FormModel, string>;
  setTwistClamp: Action<FormModel, string>;
  setDifficultToUse: Action<FormModel, string>;
  setDifficultiesMinicap: Action<FormModel, string>;
  setFlowIssue: Action<FormModel, string>;
  setBlockingFlow: Action<FormModel, string>;
  setDescribeIssue: Action<FormModel, string>;
  setEnvironment: Action<FormModel, string>;
  setSpongeVisibleMinicap: Action<FormModel, string>;
  setMaterialLocated: Action<FormModel, string>;
  setMaterialLocatedOther: Action<FormModel, string>;
  setMaterialDetails: Action<FormModel, string>;
  setMaterialEmbedded: Action<FormModel, string>;
  setComponentAppear: Action<FormModel, string>;
  setDisposableConnection: Action<FormModel, string>;
  setInitialConnection: Action<FormModel, string>;
  setSpikeLuerConnectors: Action<FormModel, string>;
  setPetsOrAnimals: Action<FormModel, string>;
  setSpikeLuerDifficulties: Action<FormModel, string>;
  setMinicapTwisted: Action<FormModel, string>;
  setTransferSet: Action<FormModel, string>;
  setResidueThreads: Action<FormModel, string>;
  setWhatAlarm: Action<FormModel, string>;
  setResidueThreadsOther: Action<FormModel, string>;
  setDifficultiesMinicapOther: Action<FormModel, string>;
  setDifficultToUseOther: Action<FormModel, string>;
  setBlockingFlowOther: Action<FormModel, string>;
  setObservedDamage: Action<FormModel, string>;
  setObservedDamageOther: Action<FormModel, string>;
  setTypeObservedDamage: Action<FormModel, string>;
  setDamageCauseLeak: Action<FormModel, string>;
  setShippingCartonOpen: Action<FormModel, string>;
  setFlowIssueObserved: Action<FormModel, string>;
  setExpiredProductFound: Action<FormModel, string>;
  setAdapterDevice: Action<FormModel, string>;
  setNameModelAdapter: Action<FormModel, string>;
  setNameModelVaporizer: Action<FormModel, string>;
  setSqueezingSolution: Action<FormModel, string>;
  setProductInformationVial: Action<FormModel, string>;
  setForthMotion: Action<FormModel, string>;
  setAlarmNoFlow: Action<FormModel, string>;
  setProductDiscolored: Action<FormModel, string>;
  setProductDiscoloredOther: Action<FormModel, string>;
  setDiscoloration: Action<FormModel, string>;
  setDiscolorationMarkings: Action<FormModel, string>;
  setChamberDiscolored: Action<FormModel, string>;
  setBrokenActivated: Action<FormModel, string>;
  setVaporizerSightGlass: Action<FormModel, string>;
  setSpecificallyDescribes: Action<FormModel, string>;
  setSpecificallyDescribesOther: Action<FormModel, string>;
  setSpecificallyDescribesAlarm: Action<FormModel, string>;
  setSpecificallyDeviceAlarm: Action<FormModel, string>;
  setComponentMisassembled: Action<FormModel, string>;
  setReconstitutionIssue: Action<FormModel, string>;
  setVolumeMedication: Action<FormModel, string>;
  setDevicesReconstitution: Action<FormModel, string>;
  setProductHeat: Action<FormModel, string>;
  setExposureTemperature: Action<FormModel, string>;
  setActivateSolution: Action<FormModel, string>;
  setDamagePriorActivation: Action<FormModel, string>;
  setDescribeDamagePrior: Action<FormModel, string>;
  setPowderFilled: Action<FormModel, string>;
  setLeakObserved: Action<FormModel, string>;
  setProductDifficult: Action<FormModel, string>;
  setHowProductDifficult: Action<FormModel, string>;
  setMatterForeignMaterial: Action<FormModel, string>;
  setMatterForeignMaterialPieces: Action<FormModel, string>;
  setMatterForeignMaterialOther: Action<FormModel, string>;
  setMatterForeignMaterialPiecesOther: Action<FormModel, string>;
  setExactTypeMaterial: Action<FormModel, string>;
  setEmbeddedInTheProduct: Action<FormModel, string>;
  setWhenMaterialObserved: Action<FormModel, string>;
  setMedicationAdded: Action<FormModel, string>;
  setReconstitutionTechnique: Action<FormModel, string>;
  setReconstitutionDevice: Action<FormModel, string>;
  setWasSolutionAddedProduct: Action<FormModel, string>;
  setWhatSolutionAddedProduct: Action<FormModel, string>;
  setCloudinessObserved: Action<FormModel, string>;
  setCloudinessGoAway: Action<FormModel, string>;
  setAgitateUnit: Action<FormModel, string>;
  setPrecipitateDissolve: Action<FormModel, string>;
  setProductStorageTemperature: Action<FormModel, string>;
  setTemperatureLogsFreezer: Action<FormModel, string>;
  setStorageUnitCalibrated: Action<FormModel, string>;
  setProductThawed: Action<FormModel, string>;
  setProductThawedOther: Action<FormModel, string>;
  setConditionsProduct: Action<FormModel, string>;
  setDamageIssueObserved: Action<FormModel, string>;
  setDamageIssueObservedOther: Action<FormModel, string>;
  setDamageSpecificInfo: Action<FormModel, string>;
  setDamageSpecificInfoOther: Action<FormModel, string>;
  setPurposeIndication: Action<FormModel, string>;
  setRouteAdministration: Action<FormModel, string>;
  setAdministrationDuration: Action<FormModel, string>;
  setDosageStrength: Action<FormModel, string>;
  setRecentPrescription: Action<FormModel, string>;
  setStorageTemperatureDetails: Action<FormModel, string>;
  setAdditivesPrior: Action<FormModel, string>;
  setAppropriateDescription: Action<FormModel, string>;
  setAppropriateDescriptionOther: Action<FormModel, string>;
  setLabelingIssue: Action<FormModel, string>;
  setLabelingIssueOther: Action<FormModel, string>;
  setExpiredProduct: Action<FormModel, string>;
  setAbnormalitiesDamage: Action<FormModel, string>;
  setPurchaseOrderNumber: Action<FormModel, string>;
  setDateAdministration: Action<FormModel, string>;
  setExpirationDateProduct: Action<FormModel, string>;
  setDescribeIncorrect: Action<FormModel, string>;
  setScannerUsed: Action<FormModel, string>;
  setOverpouchPouchScanning: Action<FormModel, string>;
  setBackgroundColorScanning: Action<FormModel, string>;
  setLabelsSameInformation: Action<FormModel, string>;
  setBarcodeScanner: Action<FormModel, string>;
  setProductsStoredFacility: Action<FormModel, string>;
  setWhatIncorrectlyDisplayed: Action<FormModel, string>;
  setWhatIncorrectlyDisplayedOther: Action<FormModel, string>;
  setMoistureObserved: Action<FormModel, string>;
  setMoistureObservedOther: Action<FormModel, string>;
  setComponentLeaking: Action<FormModel, string>;
  setComponentLeakingOther: Action<FormModel, string>;
  setFrangibleBroken: Action<FormModel, string>;
  setMoistureClear: Action<FormModel, string>;
  setMoistureClearOther: Action<FormModel, string>;
  setYourDistributor: Action<FormModel, string>;
  setVialUsed: Action<FormModel, string>;
  setSitePunctured: Action<FormModel, string>;
  setAdministrationSetUsed: Action<FormModel, string>;
  setDifficultySpiking: Action<FormModel, string>;
  setScenariosWithLeak: Action<FormModel, string>;
  setWasFrangibleDamage: Action<FormModel, string>;
  setPressureAmount: Action<FormModel, string>;
  setPressureCuff: Action<FormModel, string>;
  setSizePressureCuff: Action<FormModel, string>;
  setLeakBeingDetected: Action<FormModel, string>;
  setVaporizerNameModel: Action<FormModel, string>;
  setLiquidSpilled: Action<FormModel, string>;
  setBottleIntoVaporizer: Action<FormModel, string>;
  setVisibleDefects: Action<FormModel, string>;
  setOptionConnectionIssue: Action<FormModel, string>;
  setProductSeparated: Action<FormModel, string>;
  setWhatComponentDiscolored: Action<FormModel, string>;
  setWhatComponentDiscoloredOther: Action<FormModel, string>;
  setDescribesDiscoloration: Action<FormModel, string>;
  setDescribesDiscolorationOther: Action<FormModel, string>;
  setRemovedFromPackage: Action<FormModel, string>;
  setAddingMedication: Action<FormModel, string>;
  setWhatMedicationColor: Action<FormModel, string>;
  setWhereMatterLocated: Action<FormModel, string>;
  setWhereMatterTypes: Action<FormModel, string>;
  setEmbeddedPlastic: Action<FormModel, string>;
  setInfusateSolution: Action<FormModel, string>;
  setInfusateSolutionOther: Action<FormModel, string>;
  setMedicationsSolutions: Action<FormModel, string>;
  setDamageComponentAffected: Action<FormModel, string>;
  setDamageComponentAffectedOther: Action<FormModel, string>;
  setWhatTypeDamageIssue: Action<FormModel, string>;
  setWhatTypeDamageIssueOther: Action<FormModel, string>;
  setPatientConnectedProduct: Action<FormModel, string>;
  setWasProductReplaced: Action<FormModel, string>;
  setSituationDescribesIssue: Action<FormModel, string>;
  setSituationDescribesIssueOther: Action<FormModel, string>;
  setDescriptionLabelingIssue: Action<FormModel, string>;
  setDescriptionLabelingIssueOther: Action<FormModel, string>;
  setWhatInfoDisplayed: Action<FormModel, string>;
  setTypeScannerUsed: Action<FormModel, string>;
  setAppropriateDescIssueOther: Action<FormModel, string>;
  setWhatPurchaseOrderNumber: Action<FormModel, string>;
  setWhoDistributor: Action<FormModel, string>;
  setExpirationDatePproduct: Action<FormModel, string>;
  setLeakComingFrom: Action<FormModel, string>;
  setLeakComingFromOther: Action<FormModel, string>;
  setFollowingScenarios: Action<FormModel, string>;
  setFollowingScenariosOther: Action<FormModel, string>;
  setWasPowerInjector: Action<FormModel, string>;
  setWhatPowerInjector: Action<FormModel, string>;
  setMissingTypeInLabel: Action<FormModel, string>;
  setSecondProductInvolved: Action<FormModel, string>;
  setCrackBreak: Action<FormModel, string>;
  setCutHoleSlice: Action<FormModel, string>;
  setInjectionSiteOpening: Action<FormModel, string>;
  setInjectionSiteOpeningOther: Action<FormModel, string>;
  setProductInfoDisconnection: Action<FormModel, string>;
  setBondedComponents: Action<FormModel, string>;
  setVisibleIrregularities: Action<FormModel, string>;
  setEventuallyEstablished: Action<FormModel, string>;
  setToolUsedAssist: Action<FormModel, string>;
  setSecurePriorUse: Action<FormModel, string>;
  setPriorDisconnecting: Action<FormModel, string>;
  setSituationFlowIssue: Action<FormModel, string>;
  setFlowingBackwards: Action<FormModel, string>;
  setBackflowStopped: Action<FormModel, string>;
  setSituationsApplyEvent: Action<FormModel, string>;
  setAreaFlowIssues: Action<FormModel, string>;
  setFlowPreviouslySeen: Action<FormModel, string>;
  setPreviouslyFlowObserved: Action<FormModel, string>;
  setSimultaneousFlow: Action<FormModel, string>;
  setHangerUsed: Action<FormModel, string>;
  setHangerLength: Action<FormModel, string>;
  setBagLower: Action<FormModel, string>;
  setYSiteConnected: Action<FormModel, string>;
  setSolutionBlood: Action<FormModel, string>;
  setComponentSetReplaced: Action<FormModel, string>;
  setVolumeFluidToThePatient: Action<FormModel, string>;
  setWhatFluidInThePatient: Action<FormModel, string>;
  setWithPump: Action<FormModel, string>;
  setClampFail: Action<FormModel, string>;
  setWhatClampFailed: Action<FormModel, string>;
  setIssuesObservedClamp: Action<FormModel, string>;
  setOtherSituationsProduct: Action<FormModel, string>;
  setAlarmObserved: Action<FormModel, string>;
  setDeviceAlarm: Action<FormModel, string>;
  setWhichClampIssue: Action<FormModel, string>;
  setClampIssueExperienced: Action<FormModel, string>;
  setClampDescribesIssue: Action<FormModel, string>;
  setClampProductDifficult: Action<FormModel, string>;
  setDifficultFollowUnderstand: Action<FormModel, string>;
  setSmellComingFrom: Action<FormModel, string>;
  setClampIssueSet: Action<FormModel, string>;
  setWhereProductLeak: Action<FormModel, string>;
  setLeakOccur: Action<FormModel, string>;
  setWhichBondedComponents: Action<FormModel, string>;
  setLeakScenarios: Action<FormModel, string>;
  setProductDamaged: Action<FormModel, string>;
  setLeakObservedDamage: Action<FormModel, string>;
  setWhoIsDistributor: Action<FormModel, string>;
  setWhatComponentProdDiscolored: Action<FormModel, string>;
  setDescColorObserved: Action<FormModel, string>;
  setHowProductStored: Action<FormModel, string>;
  setMatterForeignLocated: Action<FormModel, string>;
  setSelOptionConnectionIssue: Action<FormModel, string>;
  setWhereIssueOccur: Action<FormModel, string>;
  setVisibleIrregularitiesObserved: Action<FormModel, string>;
  setOptionFlowIssue: Action<FormModel, string>;
  setHowProductSetup: Action<FormModel, string>;
  setWhatWasSimilar: Action<FormModel, string>;
  setDescOfIssue: Action<FormModel, string>;
  setShippingCartonDamaged: Action<FormModel, string>;
  setProdSupposedReceived: Action<FormModel, string>;
  setGelPacks: Action<FormModel, string>;
  setMissingUnits: Action<FormModel, string>;
  setExpiredProductUse: Action<FormModel, string>;
  setExpirationDateProd: Action<FormModel, string>;
  setExpiredProductWasFound: Action<FormModel, string>;
  setCleaningSolutions: Action<FormModel, string>;
  setDisinfectantNameBrand: Action<FormModel, string>;
  setDifficultInTwistClamp: Action<FormModel, string>;
  setComponentHadIssue: Action<FormModel, string>;
  setDamageCutHoleCrack: Action<FormModel, string>;
  setTransferReplaced: Action<FormModel, string>;
  setSelectComponentHadIssue: Action<FormModel, string>;
  setFullyTightened: Action<FormModel, string>;
  setAnyComponentDamaged: Action<FormModel, string>;
  setIssueResultLeak: Action<FormModel, string>;
  setCarrierDelivered: Action<FormModel, string>;
  setQuestionsAboutReport: Action<FormModel, string>;
  setInvestigationResults: Action<FormModel, string>;
  setOrderFromBaxter: Action<FormModel, string>;
  setQuantityCredit: Action<FormModel, string>;
  setWholesalerName: Action<FormModel, string>;
  setReporterFacility: Action<FormModel, string>;
  setReporterAddress1: Action<FormModel, string>;
  setReporterAddress2: Action<FormModel, string>;
  setReporterCity: Action<FormModel, string>;
  setReporterState: Action<FormModel, string>;
  setReporterPostalCode: Action<FormModel, string>;
  setReporterCountry: Action<FormModel, string>;
  setReporterPhone: Action<FormModel, string>;
  setEmployeeName: Action<FormModel, string>;
  setEmployeePhone: Action<FormModel, string>;
  setSamplesAvailableForEvaluation: Action<FormModel, string>;
  setAddAnotherFacility: Action<FormModel, string>;
  setOccupation: Action<FormModel, string>;
  setPhoneNumber: Action<FormModel, string>;
  setFacility: Action<FormModel, string>;
  setAlarm: Action<FormModel, string>;
  setImageOverlay: Action<FormModel, string>;
  setExplicitlyRequest: Action<FormModel, string>;
  setWerePatientUsingProduct: Action<FormModel, string>;
  setInitialProduct: Action<FormModel, any>;
  addProductToGrid: Action<FormModel, any>;
  deleteItem: Action<FormModel, any>;
  setProductInput: Action<FormModel, any>;
  setNameNotified: Action<FormModel, string>;
  setEditIndex: Action<FormModel, number>;
  setEditData: Action<FormModel, number>;
  setFacilityAddress1: Action<FormModel, string>;
  setFacilityAddress2: Action<FormModel, string>;
  setFacilityCity: Action<FormModel, string>;
  setFacilityState: Action<FormModel, string>;
  setFacilityPostalCode: Action<FormModel, string>;
  setFacilityCountry: Action<FormModel, string>;
  setAdditionalContactPhone: Action<FormModel, string>;
  setAnotherFacilityHospital: Action<FormModel, string>;
  setAnotherFacilityAddress1: Action<FormModel, string>;
  setAnotherFacilityAddress2: Action<FormModel, string>;
  setAnotherFacilityCity: Action<FormModel, string>;
  setAnotherFacilityState: Action<FormModel, string>;
  setAnotherFacilityPostalCode: Action<FormModel, string>;
  setAnotherFacilityCountry: Action<FormModel, string>;
  setMoreShowProduct: Action<FormModel, boolean>;
  setSameAsAddress1: Action<FormModel, string>;
  setSameAsAddress2: Action<FormModel, string>;
  setSameAsCity: Action<FormModel, string>;
  setSameAsState: Action<FormModel, string>;
  setSameAsPostalCode: Action<FormModel, string>;
  setSameAsCountry: Action<FormModel, string>;
  setImagesUpload: Action<FormModel, any>;
  setRemoveImage: Action<FormModel, any>;
  setAttachment: Action<FormModel, any>;
  setRemoveAttachment: Action<FormModel, any>;
  setReporterErr: Action<FormModel, boolean>;
  setProductAttachment: Action<FormModel, any>;
  setRemoveProductAttachment: Action<FormModel, any>;
  setSameAsPhoneNumber: Action<FormModel, any>;
  setSelectedCountry: Action<FormModel, any>;
  apiProductCode: Thunk<FormModel, any>;
  apiCountryRegion: Thunk<FormModel, any>;
  apiProductData: Thunk<FormModel, any>;
  setInitialProductCodeOptions: Action<FormModel, any>;
  setSelectedProductCode: Action<FormModel, any>;
  setProductFamily: Action<FormModel, any>;
  setProductType: Action<FormModel, any>;
  setErrorProductCode: Action<FormModel, boolean>;
  setErrorLotNo: Action<FormModel, boolean>;
  setSearchingLotNo: Action<FormModel, boolean>;
  setSearchingProductCode: Action<FormModel, boolean>;
  setPiecesMaterial: Action<FormModel, string>;
  setSolutionOrderedFromBaxter: Action<FormModel, string>;
  setRegion: Action<FormModel, string>;
  setShowPrivacy: Action<FormModel, boolean>;
  setAcceptedTermsTheTransfer: Action<FormModel, boolean>;
  setProvideDetails: Action<FormModel, string>;
  setMyPhoneNumber: Action<FormModel, string>;
  setPatientPhoneNumber: Action<FormModel, string>;
  setPatientIdentifier: Action<FormModel, string>;
  setPatientAddress_1: Action<FormModel, string>;
  setPatientAddress_2: Action<FormModel, string>;
  setPatientCity: Action<FormModel, string>;
  setPatientState: Action<FormModel, string>;
  setPatientPostalCode: Action<FormModel, string>;
  setPatientCountry: Action<FormModel, string>;
  setMyAddress_1: Action<FormModel, string>;
  setMyAddress_2: Action<FormModel, string>;
  setMyCity: Action<FormModel, string>;
  setMyState: Action<FormModel, string>;
  setMyPostalCode: Action<FormModel, string>;
  setMyCountry: Action<FormModel, string>;
  setDoesTheParticulate: Action<FormModel, string>;
  setPdRenalSelectTheComponent: Action<FormModel, string>;
  setShippingDistributionLabelProductCode: Action<FormModel, string>;
  setShippingDistributionLabelProductLot: Action<FormModel, string>;
  setCartonDistributionLabelProductCode: Action<FormModel, string>;
  setCartonDistributionLabelProductLot: Action<FormModel, string>;
  setInternalProductCode: Action<FormModel, string>;
  setInternalProductLot: Action<FormModel, string>;
  setAopDescriptionLabelingIssue: Action<FormModel, string>;
  setAopOptionConnectionIssue: Action<FormModel, string>;
  setLemCleaningSolutions: Action<FormModel, string>;
  setLemDisinfectantNameBrand: Action<FormModel, string>;
  setLemExcessiveForce: Action<FormModel, string>;
  setLemTransferReplaced: Action<FormModel, string>;
  setLemFollowingOccur: Action<FormModel, string>;
  setDtuTransfer: Action<FormModel, string>;
  setLemTransfer: Action<FormModel, string>;
  setScTransfer: Action<FormModel, string>;
  setLemTwistClamp: Action<FormModel, string>;
  setLemDifficultInTwistClamp: Action<FormModel, string>;
  setLiAppropriateDescription: Action<FormModel, string>;
  setFiSpecificallyDescribes: Action<FormModel, string>;
  setSiepLabelingIssue: Action<FormModel, string>;
  setLiExpiredProduct: Action<FormModel, string>;
  setOthAbnormalitiesDamage: Action<FormModel, string>;
  setLiExpirationDateProduct: Action<FormModel, string>;
  setOthMedicationsSolutions: Action<FormModel, string>;
  setSiepAopDescriptionLabelingIssue: Action<FormModel, string>;
  setScFollowingScenarios: Action<FormModel, string>;
  setScBondedComponents: Action<FormModel, string>;
  setFiVisibleIrregularitiesObserved: Action<FormModel, string>;
  setDamDescOfIssue: Action<FormModel, string>;
  setScWasPowerInjector: Action<FormModel, string>;
  setDamWasPowerInjector: Action<FormModel, string>;
  setDisHowProductStored: Action<FormModel, string>;
  setAopMaterialDetails: Action<FormModel, string>;
  setSameAsMyAddressCheck: Action<FormModel, string>;
  setSameAsPatientAddressCheck: Action<FormModel, string>;
  setSiexAccessOrderedFromBaxter: Action<FormModel, string>;
  setLiOrderedFromBaxter: Action<FormModel, string>;
  setPdrComponentHadIssue: Action<FormModel, string>;
  setTsetLemTransferReplaced: Action<FormModel, string>;
  setAopPurchaseOrderNumber: Action<FormModel, string>;
  setAopSolutionOrderedFromBaxter: Action<FormModel, string>;
  setErrorOnNext: Action<FormModel, boolean>;
  setPatientDob: Action<FormModel, string>;
  setScIssueResultLeak: Action<FormModel, string>;
  setLemAnyComponentDamaged: Action<FormModel, string>;
  setLemComponentHadIssue: Action<FormModel, string>;
  setDtuCleaningSolutions: Action<FormModel, string>;
  setScCleaningSolutions: Action<FormModel, string>;
  setAccAppropriateDescIssue: Action<FormModel, string>;
  setAccSolutionOrderedFromBaxter: Action<FormModel, string>;
  setDamComponentHadIssue: Action<FormModel, string>;
  setSolutionFlowIssueObservedDamage: Action<FormModel, string>;
  setSolutionFlowIssueTypeObservedDamage: Action<FormModel, string>;
  setSolutionFlowIssueDamageCauseLeak: Action<FormModel, string>;
  setSolutionOtherObservedDamage: Action<FormModel, string>;
  setSolutionOtherTypeObservedDamage: Action<FormModel, string>;
  setSolutionOtherDamageCauseLeak: Action<FormModel, string>;
  setSiepLeakObservedDamage: Action<FormModel, string>;
  setErrorForUncompleteForm: Action<FormModel, boolean>;
  setAcSpecificallyDeviceAlarm: Action<FormModel, string>;
  setSiepYourDistributor: Action<FormModel, string>;
  setSolPurchaseOrderNumber: Action<FormModel, string>;
  setScDisinfectantNameBrand: Action<FormModel, string>;
  setDtuDisinfectantNameBrand: Action<FormModel, string>;
  setAopMaterialLocated: Action<FormModel, string>;
  setScPdrDamageCutHoleCrack: Action<FormModel, string>;
  setScFullyTightened: Action<FormModel, string>;
  setScProductInfoDisconnection: Action<FormModel, string>;
  setLemProductInfoDisconnection: Action<FormModel, string>;
  setScAccessProductInfoDisconnection: Action<FormModel, string>;
  setSiepCarrierDelivered: Action<FormModel, string>;
  setAopExpiredProductFound: Action<FormModel, string>;
  setSubmitApiResponse: Action<FormModel, any>;
  setDoeError: Action<FormModel, boolean>;
  setUpdatedEventDate: Action<FormModel, string>;
  setHardware: Action<FormModel, string>;
  setSamePatientAddress_1: Action<FormModel, string>;
  setSamePatientAddress_2: Action<FormModel, string>;
  setSamePatientCity: Action<FormModel, string>;
  setSamePatientState: Action<FormModel, string>;
  setSamePatientPostalCode: Action<FormModel, string>;
  setSamePatientCountry: Action<FormModel, string>;
  setOtherLemComponentHadIssue: Action<FormModel, string>;
  setOtherDamComponentHadIssue: Action<FormModel, string>;
  setOtherSelectComponentHadIssue: Action<FormModel, string>;
  setOtherPdrComponentHadIssue: Action<FormModel, string>;
  setOtherComponentHadIssue: Action<FormModel, string>;
  setOtherDifficultToUse: Action<FormModel, string>;
  setOtherDifficultiesMinicap: Action<FormModel, string>;
  setOtherBlockingFlow: Action<FormModel, string>;
  setOtherDescribeIssue: Action<FormModel, string>;
  setOtherMaterialLocated: Action<FormModel, string>;
  setOtherObservedDamage: Action<FormModel, string>;
  setOtherTypeObservedDamage: Action<FormModel, string>;
  setOtherAppropriateDescription: Action<FormModel, string>;
  setOtherLiAppropriateDescription: Action<FormModel, string>;
  setOtherProductDiscolored: Action<FormModel, string>;
  setOtherSpecificallyDescribes: Action<FormModel, string>;
  setOtherMatterForeignMaterial: Action<FormModel, string>;
  setOtherMatterForeignMaterialPieces: Action<FormModel, string>;
  setOtherDamageIssueObserved: Action<FormModel, string>;
  setOtherProductThawed: Action<FormModel, string>;
  setOtherDamageSpecificInfo: Action<FormModel, string>;
  setOtherLabelingIssue: Action<FormModel, string>;
  setOtherWhatIncorrectlyDisplayed: Action<FormModel, string>;
  setOtherMoistureObserved: Action<FormModel, string>;
  setOtherComponentLeaking: Action<FormModel, string>;
  setOtherDamageComponentAffected: Action<FormModel, string>;
  setOtherWhatTypeDamageIssue: Action<FormModel, string>;
  setOtherIssueResultLeak: Action<FormModel, string>;
  setOtherSituationDescribesIssue: Action<FormModel, string>;
  setOtherDescriptionLabelingIssue: Action<FormModel, string>;
  setOtherAopDescriptionLabelingIssue: Action<FormModel, string>;
  setOtherSiepAopDescriptionLabelingIssue: Action<FormModel, string>;
  setOtherAccAppropriateDescIssue: Action<FormModel, string>;
  setOtherLeakComingFrom: Action<FormModel, string>;
  setOtherFollowingScenarios: Action<FormModel, string>;
  setOtherInjectionSiteOpening: Action<FormModel, string>;
  setOtherScIssueResultLeak: Action<FormModel, string>;
  setOtherSituationFlowIssue: Action<FormModel, string>;
  setOtherSituationsApplyEvent: Action<FormModel, string>;
  setOtherSimultaneousFlow: Action<FormModel, string>;
  setOtherWhatClampFailed: Action<FormModel, string>;
  setOtherIssuesObservedClamp: Action<FormModel, string>;
  setOtherOtherSituationsProduct: Action<FormModel, string>;
  setOtherWhichClampIssue: Action<FormModel, string>;
  setOtherClampIssueExperienced: Action<FormModel, string>;
  setOtherClampDescribesIssue: Action<FormModel, string>;
  setOtherLeakOccur: Action<FormModel, string>;
  setOtherProductDamaged: Action<FormModel, string>;
  setOtherOptionFlowIssue: Action<FormModel, string>;
  setOtherDescOfIssue: Action<FormModel, string>;
  setOtherDamDescOfIssue: Action<FormModel, string>;
  setOtherResidueThreads: Action<FormModel, string>;
  setOtherAnyComponentDamaged: Action<FormModel, string>;
  setOtherMoistureClear: Action<FormModel, string>;
  setOtherInfusateSolution: Action<FormModel, string>;
  setDrugsAndBiologics: Action<FormModel, any>;
  setScDamageCutHoleCrack: Action<FormModel, string>;
  setOtherSolutionFlowIssueobservedDamage: Action<FormModel, string>;
  setOtherSolutionOtherobservedDamage: Action<FormModel, string>;
  setOtherSolutionOtherTypeObservedDamage: Action<FormModel, string>;
  setOtherSolutionFlowIssueTypeObservedDamage: Action<FormModel, string>;
  setLotResetFlag: Action<FormModel, boolean>;
  setPcodeResetFlag: Action<FormModel, boolean>;
  setNdcResetFlag: Action<FormModel, boolean>;
  setUdiResetFlag: Action<FormModel, boolean>;
  setPnameResetFlag: Action<FormModel, boolean>;
  setAcWhatAlarm: Action<FormModel, string>;
  setIntakeFieldResetFlag: Action<FormModel, boolean>;
  setOtherFiSpecificallyDescribes: Action<FormModel, string>;
  setOtherSiepLabelingIssue: Action<FormModel, string>;
  setOtherScFollowingScenarios: Action<FormModel, string>;
  setOtherVisibleIrregularities: Action<FormModel, string>;
  setOtherAlarm: Action<FormModel, string>;
  setOtherToolUsedAssist: Action<FormModel, string>;
  setOtherDescribesDiscoloration: Action<FormModel, string>;
  setOtherWhatComponentDiscolored: Action<FormModel, string>;
  setOtherWithPump: Action<FormModel, string>;
  setRedirectPatientPhoneNumber: Action<FormModel, string>;
  setRedirectPatientEmail: Action<FormModel, string>;
  setRedirectPatientAge: Action<FormModel, string>;
  setRedirectedFromPortalFlag: Action<FormModel, boolean>;
  isUserLoggedIn: boolean;
  setIsUserLoggedIn: Action<FormModel, boolean>;
  fetchUserInfo: Thunk<FormModel, any>;
  setRedirectAccountNumber: Action<FormModel, string>;
  setYourFirstName: Action<FormModel, string>;
  setYourLastName: Action<FormModel, string>;
  setMyFirstName: Action<FormModel, string>;
  setMyLastName: Action<FormModel, string>;
  setPatientFirstName: Action<FormModel, string>;
  setPatientLastName: Action<FormModel, string>;
  setReporterFirstName: Action<FormModel, string>;
  setReporterLastName: Action<FormModel, string>;
  setEmployeeFirstName: Action<FormModel, string>;
  setEmployeeLastName: Action<FormModel, string>;
  setEndUserCostomerContactFirstName: Action<FormModel, string>;
  setEndUserCostomerContactLastName: Action<FormModel, string>;
  setAdditionalContactFirstName: Action<FormModel, string>;
  setAdditionalContactLastName: Action<FormModel, string>;
  setPQFieldResetFlag: Action<FormModel, boolean>;
  setProductCodeResetFlag: Action<FormModel, boolean>;
  setWhatMedicationSolution: Action<FormModel, string>;
  setAdditionalContact: Action<FormModel, boolean>;
  setCustomerDoesNotWish: Action<FormModel, boolean>;
  setMyAddressDoNotContact: Action<FormModel, boolean>;
  setFacilityAddressDoNotContact: Action<FormModel, boolean>;
  setEndUserCustomerFacilityName: Action<FormModel, string>;
  setEndUserCustomerFacilityPhone: Action<FormModel, string>;
  setEndUserCustomerEmail: Action<FormModel, string>;
  setEndUserCustomerFacilityAddress1: Action<FormModel, string>;
  setEndUserCustomerFacilityAddress2: Action<FormModel, string>;
  setEndUserCustomerFacilityCity: Action<FormModel, string>;
  setEndUserCustomerFacilityState: Action<FormModel, string>;
  setEndUserCustomerFacilityPostalCode: Action<FormModel, string>;
  setEndUserCustomerFacilityCountry: Action<FormModel, string>;
  setPatientAddressDoNotContact: Action<FormModel, boolean>;
  setMyAddressSameAsPatientAddressCheck: Action<FormModel, string>;
  setReturnKitAddressSameAsMyAddress: Action<FormModel, string>;
  setReturnKitAddressSameAsReporterAddress: Action<FormModel, string>;
  setReturnKitAddressSameAsPatientAddress: Action<FormModel, string>;
  setReturnKitAddressSameAsEndUserCustomerAddress: Action<FormModel, string>;
  setRedirectedFromB2bPortal: Action<FormModel, boolean>;
  setUncompleteAddressInProduct: Action<FormModel, number>;
  setIsReturnKitAddressAdded: Action<FormModel, boolean>;
}

const formModel: FormModel = {
  showError: false,
  acceptedTerms: false,
  acceptedTermsTheTransfer: false,
  showPrivacy: false,
  moreProductItem: [],
  productCodeOptions: [],
  lotResetFlag: true,
  pcodeResetFlag: true,
  ndcResetFlag: true,
  udcResetFlag: true,
  pnameResetFlag: true,
  isUserLoggedIn: false,
  isReturnKitAddressAdded: true,
  setShowError: action((state, payload) => {
    state.showError = payload;
  }),
  setAcceptedTerms: action((state, payload) => {
    state.acceptedTerms = payload;
  }),
  setRecaptchaToken: action((state, payload) => {
    state.recaptchaToken = payload;
  }),
  setRole: action((state, payload) => {
    state.role = payload;
  }),
  setSource: action((state, payload) => {
    state.source = payload;
  }),
  setEmailAddress: action((state, payload) => {
    state.emailAddress = payload;
  }),
  setAdditionalContactEmail: action((state, payload) => {
    state.additionalContactEmail = payload;
  }),
  setCareGiverEmail: action((state, payload) => {
    state.careGiverEmail = payload;
  }),
  setPatientEmail: action((state, payload) => {
    if (payload === 'decline') {
      state.redirectPatientEmailFlag = true
    }
    if (!payload && payload !== 'decline' && state.redirectPatientEmailFlag) {
      state.patientEmail = state.redirectPatientEmail;
      state.redirectPatientEmailFlag = false
    }
    else {
      state.patientEmail = payload;
    }
  }),
  setReporterEmail: action((state, payload) => {
    state.reporterEmail = payload;
  }),
  setEmployeeEmail: action((state, payload) => {
    state.employeeEmail = payload;
  }),
  setOtherEmail: action((state, payload) => {
    state.otherEmail = payload;
  }),
  setReportedTo: action((state, payload) => {
    state.reportedTo = payload;
  }),
  setReferenceNumber: action((state, payload) => {
    state.referenceNumber = payload;
  }),
  setAccountNumber: action((state, payload) => {
    state.accountNumber = payload;
  }),
  setNotificationDate: action((state, payload) => {
    state.notificationDate = payload;
  }),
  setEventDate: action((state, payload) => {
    state.eventDate = payload;
  }),
  setProcessStep: action((state, payload) => {
    state.processStep = payload;
  }),
  setWasPatientUsingProduct: action((state, payload) => {
    state.wasPatientUsingProduct = payload;
  }),
  setAdditionalInformation: action((state, payload) => {
    state.additionalInformation = payload;
  }),
  setReportedByAnotherFacility: action((state, payload) => {
    state.reportedByAnotherFacility = payload;
  }),
  setLotNo: action((state, payload) => {
    // state.lotNo = trimWhiteSpaces(payload);
    state.lotNo = payload;
  }),
  setProductName: action((state, payload) => {
    state.productName = payload;
  }),
  setProductCode: action((state, payload) => {
    // state.productCode = trimWhiteSpaces(payload);
    state.productCode = payload;
  }),
  setSelectedProductCode: action((state, payload) => {
    state.selectedProductCode = payload;

    state.errorProductCode = false;
  }),
  setNdcNo: action((state, payload) => {
    state.ndcNo = payload;
  }),
  setUdiNo: action((state, payload) => {
    state.udiNo = payload;
  }),
  setSelectedQuantity: action((state, payload) => {
    state.selectedQuantity = payload;
  }),
  setUnit: action((state, payload) => {
    state.unit = payload;
  }),
  setProblem: action((state, payload) => {
    state.reportedProblem = payload;
  }),
  setIsProductAvailableForReturn: action((state, payload) => {
    state.isTheActualProductWithReportedProblemAvailableForReturn = payload;
  }),
  setReturnQuantity: action((state, payload) => {
    state.howManySamplesReturningForInvestigation = payload;
  }),
  setIsPhotoAvailable: action((state, payload) => {
    state.isPhotoOrVideoAvailable = payload;
  }),
  setIsAvailableForReturn: action((state, payload) => {
    state.isOneUnusedBaxterProductAvailableForReturn = payload;
  }),
  setSelfImpactExperienced: action((state, payload) => {
    state.selfImpactExperienced = payload;
  }),
  setPatientImpactExperienced: action((state, payload) => {
    state.patientImpactExperienced = payload;
  }),
  setCounteractionProvided: action((state, payload) => {
    state.counteractionProvided = payload;
  }),
  setRequiredTreatment: action((state, payload) => {
    state.requiredTreatment = payload;
  }),
  setRelevantTests: action((state, payload) => {
    state.relevantTests = payload;
  }),
  setMedicalHistory: action((state, payload) => {
    state.medicalHistory = payload;
  }),
  setPatientName: action((state, payload) => {
    state.patientName = payload;
  }),
  setPatientAge: action((state, payload) => {
    let validAge = new Date().getFullYear() - 1900;
    if (parseInt(payload) <= validAge)
      payload = payload;
    // @ts-expect-error
    else if (isNaN(payload))
      payload = payload;
    else
      payload = payload;
    // payload = '';

    state.patientAge = payload;
    if (state.patientDob === 'decline' && !payload) {
      state.patientDob = 'decline';
    }
    else if (state.patientDob && (payload === undefined || payload === '')) {
      state.patientDob = state.patientDob;
    }
    else {
      state.patientDob = '';
      if (!payload && payload !== 'decline' && state.redirectPatientAge) {
        state.patientAge = state.redirectPatientAge
      }
    }
  }),
  setPatientSex: action((state, payload) => {
    state.patientSex = payload;
  }),
  setPatientGender: action((state, payload) => {
    state.patientGender = payload;
  }),
  setPatientGenderError: action((state, payload) => {
    state.patientGenderError = payload;
  }),
  setOtherPatientGender: action((state, payload) => {
    state.otherPatientGender = payload;
  }),
  setPatientWeight: action((state, payload) => {
    state.patientWeight = payload;
  }),
  setPatientWeightUnit: action((state, payload) => {
    state.patientWeightUnit = payload;
  }),
  setDrugUsedDuringEvent: action((state, payload) => {
    state.drugUsedDuringEvent = payload;
  }),
  setNameOfBaxterDrug: action((state, payload) => {
    state.nameOfBaxterDrug = payload;
  }),
  setReporterOccupation: action((state, payload) => {
    state.reporterOccupation = payload;
  }),
  setTypeOfDamage: action((state, payload) => {
    state.typeOfDamage = payload;
  }),
  setFollowingOccur: action((state, payload) => {
    state.followingOccur = payload;
  }),
  setDamageMinicap: action((state, payload) => {
    state.damageMinicap = payload;
  }),
  setExcessiveForce: action((state, payload) => {
    state.excessiveForce = payload;
  }),
  setTransfer: action((state, payload) => {
    state.transfer = payload;
  }),
  setTwistClamp: action((state, payload) => {
    state.twistClamp = payload;
  }),
  setDifficultToUse: action((state, payload) => {
    state.difficultToUse = payload;
  }),
  setDifficultiesMinicap: action((state, payload) => {
    state.difficultiesMinicap = payload;
  }),
  setFlowIssue: action((state, payload) => {
    state.flowIssue = payload;
  }),
  setBlockingFlow: action((state, payload) => {
    state.blockingFlow = payload;
  }),
  setDescribeIssue: action((state, payload) => {
    state.describeIssue = payload;
  }),
  setEnvironment: action((state, payload) => {
    state.environment = payload;
  }),
  setSpongeVisibleMinicap: action((state, payload) => {
    state.spongeVisibleMinicap = payload;
  }),
  setMaterialLocated: action((state, payload) => {
    state.materialLocated = payload;
  }),
  setMaterialLocatedOther: action((state, payload) => {
    state.materialLocatedOther = payload;
  }),
  setMaterialDetails: action((state, payload) => {
    state.materialDetails = payload;
  }),
  setMaterialEmbedded: action((state, payload) => {
    state.materialEmbedded = payload;
  }),
  setComponentAppear: action((state, payload) => {
    state.componentAppear = payload;
  }),
  setDisposableConnection: action((state, payload) => {
    state.disposableConnection = payload;
  }),
  setInitialConnection: action((state, payload) => {
    state.initialConnection = payload;
  }),
  setSpikeLuerConnectors: action((state, payload) => {
    state.spikeLuerConnectors = payload;
  }),
  setPetsOrAnimals: action((state, payload) => {
    state.petsOrAnimals = payload;
  }),
  setSpikeLuerDifficulties: action((state, payload) => {
    state.spikeLuerDifficulties = payload;
  }),
  setMinicapTwisted: action((state, payload) => {
    state.minicapTwisted = payload;
  }),
  setTransferSet: action((state, payload) => {
    state.transferSet = payload;
  }),
  setResidueThreads: action((state, payload) => {
    state.residueThreads = payload;
  }),
  setWhatAlarm: action((state, payload) => {
    state.whatAlarm = payload;
  }),
  setResidueThreadsOther: action((state, payload) => {
    state.residueThreadsOther = payload;
  }),
  setDifficultiesMinicapOther: action((state, payload) => {
    state.difficultiesMinicapOther = payload;
  }),
  setDifficultToUseOther: action((state, payload) => {
    state.difficultToUseOther = payload;
  }),
  setBlockingFlowOther: action((state, payload) => {
    state.blockingFlowOther = payload;
  }),
  setObservedDamage: action((state, payload) => {
    state.observedDamage = payload;
  }),
  setObservedDamageOther: action((state, payload) => {
    state.observedDamageOther = payload;
  }),
  setTypeObservedDamage: action((state, payload) => {
    state.typeObservedDamage = payload;
  }),
  setDamageCauseLeak: action((state, payload) => {
    state.damageCauseLeak = payload;
  }),
  setShippingCartonOpen: action((state, payload) => {
    state.shippingCartonOpen = payload;
  }),
  setFlowIssueObserved: action((state, payload) => {
    state.flowIssueObserved = payload;
  }),
  setExpiredProductFound: action((state, payload) => {
    state.expiredProductFound = payload;
  }),
  setAdapterDevice: action((state, payload) => {
    state.adapterDevice = payload;
  }),
  setNameModelAdapter: action((state, payload) => {
    state.nameModelAdapter = payload;
  }),
  setNameModelVaporizer: action((state, payload) => {
    state.nameModelVaporizer = payload;
  }),
  setSqueezingSolution: action((state, payload) => {
    state.squeezingSolution = payload;
  }),
  setProductInformationVial: action((state, payload) => {
    state.productInformationVial = payload;
  }),
  setForthMotion: action((state, payload) => {
    state.forthMotion = payload;
  }),
  setAlarmNoFlow: action((state, payload) => {
    state.alarmNoFlow = payload;
  }),
  setProductDiscolored: action((state, payload) => {
    state.productDiscolored = payload;
  }),
  setProductDiscoloredOther: action((state, payload) => {
    state.productDiscoloredOther = payload;
  }),
  setDiscoloration: action((state, payload) => {
    state.discoloration = payload;
  }),
  setDiscolorationMarkings: action((state, payload) => {
    state.discolorationMarkings = payload;
  }),
  setChamberDiscolored: action((state, payload) => {
    state.chamberDiscolored = payload;
  }),
  setBrokenActivated: action((state, payload) => {
    state.brokenActivated = payload;
  }),
  setVaporizerSightGlass: action((state, payload) => {
    state.vaporizerSightGlass = payload;
  }),
  setSpecificallyDescribes: action((state, payload) => {
    state.specificallyDescribes = payload;
  }),
  setSpecificallyDescribesOther: action((state, payload) => {
    state.specificallyDescribesOther = payload;
  }),
  setSpecificallyDescribesAlarm: action((state, payload) => {
    state.specificallyDescribesAlarm = payload;
  }),
  setSpecificallyDeviceAlarm: action((state, payload) => {
    state.specificallyDeviceAlarm = payload;
  }),
  setComponentMisassembled: action((state, payload) => {
    state.componentMisassembled = payload;
  }),
  setReconstitutionIssue: action((state, payload) => {
    state.reconstitutionIssue = payload;
  }),
  setVolumeMedication: action((state, payload) => {
    state.volumeMedication = payload;
  }),
  setDevicesReconstitution: action((state, payload) => {
    state.devicesReconstitution = payload;
  }),
  setProductHeat: action((state, payload) => {
    state.productHeat = payload;
  }),
  setExposureTemperature: action((state, payload) => {
    state.exposureTemperature = payload;
  }),
  setActivateSolution: action((state, payload) => {
    state.activateSolution = payload;
  }),
  setDamagePriorActivation: action((state, payload) => {
    state.damagePriorActivation = payload;
  }),
  setDescribeDamagePrior: action((state, payload) => {
    state.describeDamagePrior = payload;
  }),
  setPowderFilled: action((state, payload) => {
    state.powderFilled = payload;
  }),
  setLeakObserved: action((state, payload) => {
    state.leakObserved = payload;
  }),
  setProductDifficult: action((state, payload) => {
    state.productDifficult = payload;
  }),
  setHowProductDifficult: action((state, payload) => {
    state.howProductDifficult = payload;
  }),
  setMatterForeignMaterial: action((state, payload) => {
    state.matterForeignMaterial = payload;
  }),
  setMatterForeignMaterialPieces: action((state, payload) => {
    state.matterForeignMaterialPieces = payload;
  }),
  setMatterForeignMaterialOther: action((state, payload) => {
    state.matterForeignMaterialOther = payload;
  }),
  setMatterForeignMaterialPiecesOther: action((state, payload) => {
    state.matterForeignMaterialPiecesOther = payload;
  }),
  setExactTypeMaterial: action((state, payload) => {
    state.exactTypeMaterial = payload;
  }),
  setEmbeddedInTheProduct: action((state, payload) => {
    state.embeddedInTheProduct = payload;
  }),
  setWhenMaterialObserved: action((state, payload) => {
    state.whenMaterialObserved = payload;
  }),
  setMedicationAdded: action((state, payload) => {
    state.medicationAdded = payload;
  }),
  setReconstitutionTechnique: action((state, payload) => {
    state.reconstitutionTechnique = payload;
  }),
  setReconstitutionDevice: action((state, payload) => {
    state.reconstitutionDevice = payload;
  }),
  setWasSolutionAddedProduct: action((state, payload) => {
    state.wasSolutionAddedProduct = payload;
  }),
  setWhatSolutionAddedProduct: action((state, payload) => {
    state.whatSolutionAddedProduct = payload;
  }),
  setCloudinessObserved: action((state, payload) => {
    state.cloudinessObserved = payload;
  }),
  setCloudinessGoAway: action((state, payload) => {
    state.cloudinessGoAway = payload;
  }),
  setAgitateUnit: action((state, payload) => {
    state.agitateUnit = payload;
  }),
  setPrecipitateDissolve: action((state, payload) => {
    state.precipitateDissolve = payload;
  }),
  setProductStorageTemperature: action((state, payload) => {
    state.productStorageTemperature = payload;
  }),
  setTemperatureLogsFreezer: action((state, payload) => {
    state.temperatureLogsFreezer = payload;
  }),
  setStorageUnitCalibrated: action((state, payload) => {
    state.storageUnitCalibrated = payload;
  }),
  setProductThawed: action((state, payload) => {
    state.productThawed = payload;
  }),
  setProductThawedOther: action((state, payload) => {
    state.productThawedOther = payload;
  }),
  setConditionsProduct: action((state, payload) => {
    state.conditionsProduct = payload;
  }),
  setDamageIssueObserved: action((state, payload) => {
    state.damageIssueObserved = payload;
  }),
  setDamageIssueObservedOther: action((state, payload) => {
    state.damageIssueObservedOther = payload;
  }),
  setDamageSpecificInfo: action((state, payload) => {
    state.damageSpecificInfo = payload;
  }),
  setDamageSpecificInfoOther: action((state, payload) => {
    state.damageSpecificInfoOther = payload;
  }),
  setPurposeIndication: action((state, payload) => {
    state.purposeIndication = payload;
  }),
  setRouteAdministration: action((state, payload) => {
    state.routeAdministration = payload;
  }),
  setAdministrationDuration: action((state, payload) => {
    state.administrationDuration = payload;
  }),
  setDosageStrength: action((state, payload) => {
    state.dosageStrength = payload;
  }),
  setRecentPrescription: action((state, payload) => {
    state.recentPrescription = payload;
  }),
  setStorageTemperatureDetails: action((state, payload) => {
    state.storageTemperatureDetails = payload;
  }),
  setAdditivesPrior: action((state, payload) => {
    state.additivesPrior = payload;
  }),
  setAppropriateDescription: action((state, payload) => {
    state.appropriateDescription = payload;
  }),
  setAppropriateDescriptionOther: action((state, payload) => {
    state.appropriateDescriptionOther = payload;
  }),
  setLabelingIssue: action((state, payload) => {
    state.labelingIssue = payload;
  }),
  setLabelingIssueOther: action((state, payload) => {
    state.labelingIssueOther = payload;
  }),
  setExpiredProduct: action((state, payload) => {
    state.expiredProduct = payload;
  }),
  setAbnormalitiesDamage: action((state, payload) => {
    state.abnormalitiesDamage = payload;
  }),
  setPurchaseOrderNumber: action((state, payload) => {
    state.purchaseOrderNumber = payload;
  }),
  setDateAdministration: action((state, payload) => {
    state.dateAdministration = payload;
  }),
  setExpirationDateProduct: action((state, payload) => {
    state.expirationDateProduct = payload;
  }),
  setDescribeIncorrect: action((state, payload) => {
    state.describeIncorrect = payload;
  }),
  setScannerUsed: action((state, payload) => {
    state.scannerUsed = payload;
  }),
  setOverpouchPouchScanning: action((state, payload) => {
    state.overpouchPouchScanning = payload;
  }),
  setBackgroundColorScanning: action((state, payload) => {
    state.backgroundColorScanning = payload;
  }),
  setLabelsSameInformation: action((state, payload) => {
    state.labelsSameInformation = payload;
  }),
  setBarcodeScanner: action((state, payload) => {
    state.barcodeScanner = payload;
  }),
  setProductsStoredFacility: action((state, payload) => {
    state.productsStoredFacility = payload;
  }),
  setWhatIncorrectlyDisplayed: action((state, payload) => {
    state.whatIncorrectlyDisplayed = payload;
  }),
  setWhatIncorrectlyDisplayedOther: action((state, payload) => {
    state.whatIncorrectlyDisplayedOther = payload;
  }),
  setMoistureObserved: action((state, payload) => {
    state.moistureObserved = payload;
  }),
  setMoistureObservedOther: action((state, payload) => {
    state.moistureObservedOther = payload;
  }),
  setComponentLeaking: action((state, payload) => {
    state.componentLeaking = payload;
  }),
  setComponentLeakingOther: action((state, payload) => {
    state.componentLeakingOther = payload;
  }),
  setFrangibleBroken: action((state, payload) => {
    state.frangibleBroken = payload;
  }),
  setMoistureClear: action((state, payload) => {
    state.moistureClear = payload;
  }),
  setMoistureClearOther: action((state, payload) => {
    state.moistureClearOther = payload;
  }),
  setYourDistributor: action((state, payload) => {
    state.yourDistributor = payload;
  }),
  setVialUsed: action((state, payload) => {
    state.vialUsed = payload;
  }),
  setSitePunctured: action((state, payload) => {
    state.sitePunctured = payload;
  }),
  setAdministrationSetUsed: action((state, payload) => {
    state.administrationSetUsed = payload;
  }),
  setDifficultySpiking: action((state, payload) => {
    state.difficultySpiking = payload;
  }),
  setScenariosWithLeak: action((state, payload) => {
    state.scenariosWithLeak = payload;
  }),
  setWasFrangibleDamage: action((state, payload) => {
    state.wasFrangibleDamage = payload;
  }),
  setPressureAmount: action((state, payload) => {
    state.pressureAmount = payload;
  }),
  setPressureCuff: action((state, payload) => {
    state.pressureCuff = payload;
  }),
  setSizePressureCuff: action((state, payload) => {
    state.sizePressureCuff = payload;
  }),
  setLeakBeingDetected: action((state, payload) => {
    state.leakBeingDetected = payload;
  }),
  setVaporizerNameModel: action((state, payload) => {
    state.vaporizerNameModel = payload;
  }),
  setLiquidSpilled: action((state, payload) => {
    state.liquidSpilled = payload;
  }),
  setBottleIntoVaporizer: action((state, payload) => {
    state.bottleIntoVaporizer = payload;
  }),
  setVisibleDefects: action((state, payload) => {
    state.visibleDefects = payload;
  }),
  setOptionConnectionIssue: action((state, payload) => {
    state.optionConnectionIssue = payload;
  }),
  setProductSeparated: action((state, payload) => {
    state.productSeparated = payload;
  }),
  setWhatComponentDiscolored: action((state, payload) => {
    state.whatComponentDiscolored = payload;
  }),
  setWhatComponentDiscoloredOther: action((state, payload) => {
    state.whatComponentDiscoloredOther = payload;
  }),
  setDescribesDiscoloration: action((state, payload) => {
    state.describesDiscoloration = payload;
  }),
  setDescribesDiscolorationOther: action((state, payload) => {
    state.describesDiscolorationOther = payload;
  }),
  setRemovedFromPackage: action((state, payload) => {
    state.removedFromPackage = payload;
  }),
  setAddingMedication: action((state, payload) => {
    state.addingMedication = payload;
  }),
  setWhatMedicationColor: action((state, payload) => {
    state.whatMedicationColor = payload;
  }),
  setWhereMatterLocated: action((state, payload) => {
    state.whereMatterLocated = payload;
  }),
  setWhereMatterTypes: action((state, payload) => {
    state.whereMatterTypes = payload;
  }),
  setEmbeddedPlastic: action((state, payload) => {
    state.embeddedPlastic = payload;
  }),
  setInfusateSolution: action((state, payload) => {
    state.infusateSolution = payload;
  }),
  setInfusateSolutionOther: action((state, payload) => {
    state.infusateSolutionOther = payload;
  }),
  setMedicationsSolutions: action((state, payload) => {
    state.medicationsSolutions = payload;
  }),
  setDamageComponentAffected: action((state, payload) => {
    state.damageComponentAffected = payload;
  }),
  setDamageComponentAffectedOther: action((state, payload) => {
    state.damageComponentAffectedOther = payload;
  }),
  setWhatTypeDamageIssue: action((state, payload) => {
    state.whatTypeDamageIssue = payload;
  }),
  setWhatTypeDamageIssueOther: action((state, payload) => {
    state.whatTypeDamageIssueOther = payload;
  }),
  setPatientConnectedProduct: action((state, payload) => {
    state.patientConnectedProduct = payload;
  }),
  setWasProductReplaced: action((state, payload) => {
    state.wasProductReplaced = payload;
  }),
  setSituationDescribesIssue: action((state, payload) => {
    state.situationDescribesIssue = payload;
  }),
  setSituationDescribesIssueOther: action((state, payload) => {
    state.situationDescribesIssueOther = payload;
  }),
  setDescriptionLabelingIssue: action((state, payload) => {
    state.descriptionLabelingIssue = payload;
  }),
  setDescriptionLabelingIssueOther: action((state, payload) => {
    state.descriptionLabelingIssueOther = payload;
  }),
  setWhatInfoDisplayed: action((state, payload) => {
    state.whatInfoDisplayed = payload;
  }),
  setTypeScannerUsed: action((state, payload) => {
    state.typeScannerUsed = payload;
  }),
  setAppropriateDescIssueOther: action((state, payload) => {
    state.appropriateDescIssueOther = payload;
  }),
  setWhatPurchaseOrderNumber: action((state, payload) => {
    state.whatPurchaseOrderNumber = payload;
  }),
  setWhoDistributor: action((state, payload) => {
    state.whoDistributor = payload;
  }),
  setExpirationDatePproduct: action((state, payload) => {
    state.expirationDatePproduct = payload;
  }),
  setLeakComingFrom: action((state, payload) => {
    state.leakComingFrom = payload;
  }),
  setLeakComingFromOther: action((state, payload) => {
    state.leakComingFromOther = payload;
  }),
  setFollowingScenarios: action((state, payload) => {
    state.followingScenarios = payload;
  }),
  setFollowingScenariosOther: action((state, payload) => {
    state.followingScenariosOther = payload;
  }),
  setWasPowerInjector: action((state, payload) => {
    state.wasPowerInjector = payload;
  }),
  setWhatPowerInjector: action((state, payload) => {
    state.whatPowerInjector = payload;
  }),
  setMissingTypeInLabel: action((state, payload) => {
    state.missingTypeInLabel = payload;
  }),
  setSecondProductInvolved: action((state, payload) => {
    state.secondProductInvolved = payload;
  }),
  setCrackBreak: action((state, payload) => {
    state.crackBreak = payload;
  }),
  setCutHoleSlice: action((state, payload) => {
    state.cutHoleSlice = payload;
  }),
  setInjectionSiteOpening: action((state, payload) => {
    state.injectionSiteOpening = payload;
  }),
  setInjectionSiteOpeningOther: action((state, payload) => {
    state.injectionSiteOpeningOther = payload;
  }),
  setProductInfoDisconnection: action((state, payload) => {
    state.productInfoDisconnection = payload;
  }),
  setBondedComponents: action((state, payload) => {
    state.bondedComponents = payload;
  }),
  setVisibleIrregularities: action((state, payload) => {
    state.visibleIrregularities = payload;
  }),
  setEventuallyEstablished: action((state, payload) => {
    state.eventuallyEstablished = payload;
  }),
  setToolUsedAssist: action((state, payload) => {
    state.toolUsedAssist = payload;
  }),
  setSecurePriorUse: action((state, payload) => {
    state.securePriorUse = payload;
  }),
  setPriorDisconnecting: action((state, payload) => {
    state.priorDisconnecting = payload;
  }),
  setSituationFlowIssue: action((state, payload) => {
    state.situationFlowIssue = payload;
  }),
  setFlowingBackwards: action((state, payload) => {
    state.flowingBackwards = payload;
  }),
  setBackflowStopped: action((state, payload) => {
    state.backflowStopped = payload;
  }),
  setSituationsApplyEvent: action((state, payload) => {
    state.situationsApplyEvent = payload;
  }),
  setAreaFlowIssues: action((state, payload) => {
    state.areaFlowIssues = payload;
  }),
  setFlowPreviouslySeen: action((state, payload) => {
    state.flowPreviouslySeen = payload;
  }),
  setPreviouslyFlowObserved: action((state, payload) => {
    state.previouslyFlowObserved = payload;
  }),
  setSimultaneousFlow: action((state, payload) => {
    state.simultaneousFlow = payload;
  }),
  setHangerUsed: action((state, payload) => {
    state.hangerUsed = payload;
  }),
  setHangerLength: action((state, payload) => {
    state.hangerLength = payload;
  }),
  setBagLower: action((state, payload) => {
    state.bagLower = payload;
  }),
  setYSiteConnected: action((state, payload) => {
    state.ySiteConnected = payload;
  }),
  setSolutionBlood: action((state, payload) => {
    state.solutionBlood = payload;
  }),
  setComponentSetReplaced: action((state, payload) => {
    state.componentSetReplaced = payload;
  }),
  setVolumeFluidToThePatient: action((state, payload) => {
    state.volumeFluidToThePatient = payload;
  }),
  setWhatFluidInThePatient: action((state, payload) => {
    state.whatFluidInThePatient = payload;
  }),
  setWithPump: action((state, payload) => {
    state.withPump = payload;
  }),
  setClampFail: action((state, payload) => {
    state.clampFail = payload;
  }),
  setWhatClampFailed: action((state, payload) => {
    state.whatClampFailed = payload;
  }),
  setIssuesObservedClamp: action((state, payload) => {
    state.issuesObservedClamp = payload;
  }),
  setOtherSituationsProduct: action((state, payload) => {
    state.otherSituationsProduct = payload;
  }),
  setAlarmObserved: action((state, payload) => {
    state.alarmObserved = payload;
  }),
  setDeviceAlarm: action((state, payload) => {
    state.deviceAlarm = payload;
  }),
  setWhichClampIssue: action((state, payload) => {
    state.whichClampIssue = payload;
  }),
  setClampIssueExperienced: action((state, payload) => {
    state.clampIssueExperienced = payload;
  }),
  setClampDescribesIssue: action((state, payload) => {
    state.clampDescribesIssue = payload;
  }),
  setClampProductDifficult: action((state, payload) => {
    state.clampProductDifficult = payload;
  }),
  setDifficultFollowUnderstand: action((state, payload) => {
    state.difficultFollowUnderstand = payload;
  }),
  setSmellComingFrom: action((state, payload) => {
    state.smellComingFrom = payload;
  }),
  setClampIssueSet: action((state, payload) => {
    state.clampIssueSet = payload;
  }),
  setWhereProductLeak: action((state, payload) => {
    state.whereProductLeak = payload;
  }),
  setLeakOccur: action((state, payload) => {
    state.leakOccur = payload;
  }),
  setWhichBondedComponents: action((state, payload) => {
    state.whichBondedComponents = payload;
  }),
  setLeakScenarios: action((state, payload) => {
    state.leakScenarios = payload;
  }),
  setProductDamaged: action((state, payload) => {
    state.productDamaged = payload;
  }),
  setLeakObservedDamage: action((state, payload) => {
    state.leakObservedDamage = payload;
  }),
  setWhoIsDistributor: action((state, payload) => {
    state.whoIsDistributor = payload;
  }),
  setWhatComponentProdDiscolored: action((state, payload) => {
    state.whatComponentProdDiscolored = payload;
  }),
  setDescColorObserved: action((state, payload) => {
    state.descColorObserved = payload;
  }),
  setHowProductStored: action((state, payload) => {
    state.howProductStored = payload;
  }),
  setMatterForeignLocated: action((state, payload) => {
    state.matterForeignLocated = payload;
  }),
  setSelOptionConnectionIssue: action((state, payload) => {
    state.selOptionConnectionIssue = payload;
  }),
  setWhereIssueOccur: action((state, payload) => {
    state.whereIssueOccur = payload;
  }),
  setVisibleIrregularitiesObserved: action((state, payload) => {
    state.visibleIrregularitiesObserved = payload;
  }),
  setOptionFlowIssue: action((state, payload) => {
    state.optionFlowIssue = payload;
  }),
  setHowProductSetup: action((state, payload) => {
    state.howProductSetup = payload;
  }),
  setWhatWasSimilar: action((state, payload) => {
    state.whatWasSimilar = payload;
  }),
  setDescOfIssue: action((state, payload) => {
    state.descOfIssue = payload;
  }),
  setShippingCartonDamaged: action((state, payload) => {
    state.shippingCartonDamaged = payload;
  }),
  setProdSupposedReceived: action((state, payload) => {
    state.prodSupposedReceived = payload;
  }),
  setGelPacks: action((state, payload) => {
    state.gelPacks = payload;
  }),
  setMissingUnits: action((state, payload) => {
    state.missingUnits = payload;
  }),
  setExpiredProductUse: action((state, payload) => {
    state.expiredProductUse = payload;
  }),
  setExpirationDateProd: action((state, payload) => {
    state.expirationDateProd = payload;
  }),
  setExpiredProductWasFound: action((state, payload) => {
    state.expiredProductWasFound = payload;
  }),
  setCleaningSolutions: action((state, payload) => {
    state.cleaningSolutions = payload;
  }),
  setDisinfectantNameBrand: action((state, payload) => {
    state.disinfectantNameBrand = payload;
  }),
  setDifficultInTwistClamp: action((state, payload) => {
    state.difficultInTwistClamp = payload;
  }),
  setComponentHadIssue: action((state, payload) => {
    state.componentHadIssue = payload;
  }),
  setDamageCutHoleCrack: action((state, payload) => {
    state.damageCutHoleCrack = payload;
  }),
  setTransferReplaced: action((state, payload) => {
    state.transferReplaced = payload;
  }),
  setSelectComponentHadIssue: action((state, payload) => {
    state.selectComponentHadIssue = payload;
  }),
  setFullyTightened: action((state, payload) => {
    state.fullyTightened = payload;
  }),
  setAnyComponentDamaged: action((state, payload) => {
    state.anyComponentDamaged = payload;
  }),
  setIssueResultLeak: action((state, payload) => {
    state.issueResultLeak = payload;
  }),
  setCarrierDelivered: action((state, payload) => {
    state.carrierDelivered = payload;
  }),
  setQuestionsAboutReport: action((state, payload) => {
    state.contactInformationForaddtionalQuestionsAboutReport = payload;
  }),
  setInvestigationResults: action((state, payload) => {
    state.investigationResults = payload;
  }),
  setOrderFromBaxter: action((state, payload) => {
    state.orderFromBaxter = payload;
  }),
  setQuantityCredit: action((state, payload) => {
    state.quantityCredit = payload;
  }),
  setWholesalerName: action((state, payload) => {
    state.wholesalerName = payload;
  }),
  setReporterFacility: action((state, payload) => {
    state.reporterFacility = payload;
  }),
  setReporterAddress1: action((state, payload) => {
    state.reporterAddress1 = payload;
  }),
  setReporterAddress2: action((state, payload) => {
    state.reporterAddress2 = payload;
  }),
  setReporterCity: action((state, payload) => {
    state.reporterCity = payload;
  }),
  setReporterState: action((state, payload) => {
    state.reporterState = payload;
  }),
  setReporterPostalCode: action((state, payload) => {
    state.reporterPostalCode = payload;
  }),
  setReporterCountry: action((state, payload) => {
    state.reporterCountry = payload;
  }),
  setReporterPhone: action((state, payload) => {
    state.reporterPhone = payload;
  }),
  setEmployeeName: action((state, payload) => {
    state.employeeName = payload;
  }),
  setEmployeePhone: action((state, payload) => {
    state.employeePhone = payload;
  }),
  setSamplesAvailableForEvaluation: action((state, payload) => {
    state.AreYouAbleToBringAvailableSampleToYourHealthcareProviderForEvaluation = payload;
  }),
  setAddAnotherFacility: action((state, payload) => {
    state.addAnotherFacility = payload;
  }),
  setOccupation: action((state, payload) => {
    state.occupation = payload;
  }),
  setPhoneNumber: action((state, payload) => {
    state.phoneNumber = payload;
  }),
  setFacility: action((state, payload) => {
    state.facility = payload;
  }),
  setAlarm: action((state, payload) => {
    state.alarm = payload;
  }),
  setImageOverlay: action((state, payload) => {
    state.imageOverlay = payload;
  }),
  setExplicitlyRequest: action((state, payload) => {
    state.explicitlyRequest = payload;
  }),
  setWerePatientUsingProduct: action((state, payload) => {
    state.werePatientUsingProduct = payload;
  }),
  setInitialProduct: action((state, moreProductItem) => {
    state.moreProductItem = moreProductItem;
  }),
  addProductToGrid: action((state, payload) => {
    state.moreProductItem.push(payload);
  }),
  deleteItem: action((state, payload) => {
    state.moreProductItem = state.moreProductItem.filter((pitem: any, key: Number) => key !== payload);
    state.moreShowProductArea = true;
    state.editIndex = undefined;
  }),
  setProductInput: action((state, payload) => {
    state.moreProductItem[payload[0]][payload[1]] = [payload[2]];
  }),
  setNameNotified: action((state, payload) => {
    state.nameNotified = payload;
  }),
  setEditIndex: action((state, payload) => {
    state.editIndex = payload;
  }),
  setEditData: action((state, payload) => {	
    const mp = state.moreProductItem	
    // @ts-expect-error	
    const index = payload[0];	
    // @ts-expect-error	
    const returnKitAddressAdded = payload[1];	
    mp[index]['uploadImage'] = []	
    mp[index]['lotNo'] = state.lotNo	
    mp[index]['selectedQuantity'] = state.selectedQuantity	
    mp[index]['unit'] = state.unit	
    mp[index]['reportedProblem'] = state.reportedProblem	
    mp[index]['productCode'] = state.productCode || state.selectedProductCode	
    mp[index]['productName'] = state.productName	
    mp[index]['ndcNo'] = state.ndcNo	
    mp[index]['udiNo'] = state.udiNo	
    mp[index]['AreYouAbleToBringAvailableSampleToYourHealthcareProviderForEvaluation'] = state.AreYouAbleToBringAvailableSampleToYourHealthcareProviderForEvaluation	
    mp[index]['isTheActualProductWithReportedProblemAvailableForReturn'] = state.isTheActualProductWithReportedProblemAvailableForReturn	
    mp[index]['howManySamplesReturningForInvestigation'] = state.howManySamplesReturningForInvestigation	
    mp[index]['isPhotoOrVideoAvailable'] = state.isPhotoOrVideoAvailable	
    mp[index]['isOneUnusedBaxterProductAvailableForReturn'] = state.isOneUnusedBaxterProductAvailableForReturn	
    mp[index]['uploadImage'] = state.uploadImage	
    mp[index]['productType'] = state.productType	
    mp[index]['productFamily'] = state.productFamily	
    mp[index]['hardware'] = state.hardware	
    mp[index]['returnKitAddressAdded'] = returnKitAddressAdded	
    mp[index]['contactInformationForaddtionalQuestionsAboutReport'] = state.contactInformationForaddtionalQuestionsAboutReport	
    mp[index]['drugsAndBiologics'] = state.drugsAndBiologics	
    state.editIndex = undefined
  }),
  setFacilityAddress1: action((state, payload) => {
    state.facilityAddress1 = payload;
  }),
  setFacilityAddress2: action((state, payload) => {
    state.facilityAddress2 = payload;
  }),
  setFacilityCity: action((state, payload) => {
    state.facilityCity = payload;
  }),
  setFacilityState: action((state, payload) => {
    state.facilityState = payload;
  }),
  setFacilityPostalCode: action((state, payload) => {
    state.facilityPostalCode = payload;
  }),
  setFacilityCountry: action((state, payload) => {
    state.facilityCountry = payload;
  }),
  setAdditionalContactPhone: action((state, payload) => {
    state.additionalContactPhone = payload;
  }),
  setAnotherFacilityHospital: action((state, payload) => {
    state.anotherFacilityHospital = payload;
  }),
  setAnotherFacilityAddress1: action((state, payload) => {
    state.anotherFacilityAddress1 = payload;
  }),
  setAnotherFacilityAddress2: action((state, payload) => {
    state.anotherFacilityAddress2 = payload;
  }),
  setAnotherFacilityCity: action((state, payload) => {
    state.anotherFacilityCity = payload;
  }),
  setAnotherFacilityState: action((state, payload) => {
    state.anotherFacilityState = payload;
  }),
  setAnotherFacilityPostalCode: action((state, payload) => {
    state.anotherFacilityPostalCode = payload;
  }),
  setAnotherFacilityCountry: action((state, payload) => {
    state.anotherFacilityCountry = payload;
  }),
  setMoreShowProduct: action((state, payload) => {
    state.moreShowProductArea = payload;
  }),
  setSameAsAddress1: action((state, payload) => {
    state.sameAsAddress1 = payload;
  }),
  setSameAsAddress2: action((state, payload) => {
    state.sameAsAddress2 = payload;
  }),
  setSameAsCity: action((state, payload) => {
    state.sameAsCity = payload;
  }),
  setSameAsState: action((state, payload) => {
    state.sameAsState = payload;
  }),
  setSameAsPostalCode: action((state, payload) => {
    state.sameAsPostalCode = payload;
  }),
  setSameAsCountry: action((state, payload) => {
    state.sameAsCountry = payload;
  }),
  setImagesUpload: action((state, payload) => {
    let img = []
    if (payload && state.uploadImage) {
      img = [...state.uploadImage, ...payload];
    }
    else {
      img = payload;
    }
    const key = 'name';
    // @ts-expect-error
    state.uploadImage = [...new Map(img?.map(item =>
      [item[key], item])).values()];
  }),
  setRemoveImage: action((state, payload) => {
    state.uploadImage = state.uploadImage.filter((item: any, key: Number) => key !== payload);
  }),
  setAttachment: action((state, payload) => {
    if (payload && state.attachment)
      state.attachment = [...state.attachment, ...payload];
    else
      state.attachment = payload;
  }),
  setRemoveAttachment: action((state, payload) => {
    state.attachment = state.attachment.filter((item: any, key: Number) => key !== payload);
  }),
  setReporterErr: action((state, payload) => {
    state.reporterErr = payload;
  }),
  setProductAttachment: action((state, payload) => {
    if (payload && state.productattachment)
      state.productattachment = [...state.productattachment, ...payload];
    else
      state.productattachment = payload;
  }),
  setRemoveProductAttachment: action((state, payload) => {
    state.productattachment = state.productattachment.filter((item: any, key: Number) => key !== payload);
  }),
  setSameAsPhoneNumber: action((state, payload) => {
    state.sameAsPhoneNumber = payload;
  }),
  setSelectedCountry: action((state, payload) => {
    state.selectedCountry = payload;
  }),

  apiProductCode: thunk(async (actions, payload) => {
    var apiResponse: any = await fetchProductCode(payload);
    var pdata = apiResponse?.products ? apiResponse?.products : [];
    //render option dropdown
    actions.setInitialProductCodeOptions([])


    // actions.setNdcResetFlag(true)

    // actions.setUdiResetFlag(true)

    if (pdata) {
      const pd = pdata[0];
      if (payload && payload[0] !== undefined) {
        if (pdata.length === 0)
          actions.setErrorLotNo(true)
        else
          actions.setSearchingLotNo(false)
        if (pdata.length === 1) {


          actions.setPcodeResetFlag(false)

          // if (pd['ndcNo'])
            actions.setNdcResetFlag(true)

          // if (pd['udiNo'])
            actions.setUdiResetFlag(true)

          if (pd['productName'])
            actions.setPnameResetFlag(true)

          if (pd['productCode'])
            actions.setProductCodeResetFlag(true)

          actions.setNdcNo(pd['ndcNo'])
          actions.setUdiNo(pd['udiNo'])
          actions.setProductName(pd['productName'])
          actions.setProductCode(pd['productCode'])
          actions.setProductFamily(pd['productFamily'])
          actions.setProductType(pd['productType'])
          actions.setHardware(pd['hardware'])
          actions.setDrugsAndBiologics(pd['drugsAndBiologics'])
        } else {
          let arr: any = [];
          pdata.map((d: any) => arr.push({ value: d.productCode, label: d.productCode }))
          actions.setInitialProductCodeOptions(arr)
        }
      }
      //product code condition
      if ((payload && payload[1] !== undefined)) {
        if (pdata.length === 0)
          actions.setErrorProductCode(true)
        else
          actions.setSearchingProductCode(false)
        if (pdata.length === 1) {
          const pd = pdata[0];

          if (pd['ndcNo'])
            actions.setNdcResetFlag(true)

          if (pd['udiNo'])
            actions.setUdiResetFlag(true)

          if (pd['productName'])
            actions.setPnameResetFlag(true)

          if (pd['productCode'])
            actions.setProductCodeResetFlag(true)

          actions.setNdcNo(pd['ndcNo'])
          actions.setUdiNo(pd['udiNo'])
          actions.setProductName(pd['productName'])
          actions.setProductFamily(pd['productFamily'])
          actions.setProductType(pd['productType'])
          actions.setHardware(pd['hardware'])
          actions.setDrugsAndBiologics(pd['drugsAndBiologics'])
        }
      }
    }
  }),

  apiProductData: thunk(async (actions, payload) => {
    var apiResponse: any = await fetchProductData(payload);
    var pdata = apiResponse?.products ? apiResponse?.products : [];
    
      actions.setNdcResetFlag(true)

      actions.setUdiResetFlag(true)

    if (pdata.length === 0) {
      actions.setErrorProductCode(true)
      actions.setSearchingProductCode(false)
      actions.setNdcNo('');
      actions.setUdiNo('');
      actions.setProductName('');
      actions.setProductFamily('');
      actions.setProductType('');
      actions.setHardware('');
      actions.setDrugsAndBiologics('');

    } else {
      actions.setErrorProductCode(false)
    }

    if (pdata) {
      const pd = pdata[0];
      if (pdata.length === 1) {
        // if (pd['ndcNo'])
        //   actions.setNdcResetFlag(true)

        // if (pd['udiNo'])
        //   actions.setUdiResetFlag(true)

        if (pd['productName'])
          actions.setPnameResetFlag(true)

        actions.setNdcNo(pd['ndcNo'])
        actions.setUdiNo(pd['udiNo'])
        actions.setProductName(pd['productName'])
        actions.setProductFamily(pd['productFamily'])
        actions.setProductType(pd['productType'])
        actions.setHardware(pd['hardware'])
        actions.setDrugsAndBiologics(pd['drugsAndBiologics'])
      }
    }
  }),
  apiCountryRegion: thunk(async (actions, payload) => {
    var region: any = await fetchCountryRegion(payload);
    if (region)
      actions.setRegion(region)
  }),
  setInitialProductCodeOptions: action((state, productCodeOptions) => {
    state.productCodeOptions = productCodeOptions;
  }),
  setProductFamily: action((state, payload) => {
    state.productFamily = payload;
  }),
  setProductType: action((state, payload) => {
    state.productType = payload;
  }),
  setErrorProductCode: action((state, payload) => {
    state.errorProductCode = payload;
  }),
  setErrorLotNo: action((state, payload) => {
    state.errorLotNo = payload;
  }),
  setSearchingLotNo: action((state, payload) => {
    state.searchingLotNo = payload;
  }),
  setSearchingProductCode: action((state, payload) => {
    state.searchingProductCode = payload;
  }),
  setPiecesMaterial: action((state, payload) => {
    state.piecesMaterial = payload;
  }),
  setSolutionOrderedFromBaxter: action((state, payload) => {
    state.solutionOrderedFromBaxter = payload;
  }),
  setRegion: action((state, payload) => {
    state.region = payload;
  }),
  setShowPrivacy: action((state, payload) => {
    state.showPrivacy = payload;
  }),
  setAcceptedTermsTheTransfer: action((state, payload) => {
    state.acceptedTermsTheTransfer = payload;
  }),
  setProvideDetails: action((state, payload) => {
    state.provideDetails = payload;
  }),
  setMyPhoneNumber: action((state, payload) => {
    state.myPhoneNumber = payload;
  }),
  setPatientPhoneNumber: action((state, payload) => {
    if (payload === 'decline') {
      state.redirectPatientPhoneNumberFlag = true
    }
    if (!payload && payload !== 'decline' && state.redirectPatientPhoneNumberFlag) {
      state.patientPhoneNumber = state.redirectPatientPhoneNumber;
      state.redirectPatientPhoneNumberFlag = false
    }
    else {
      state.patientPhoneNumber = payload;
    }
  }),
  setPatientIdentifier: action((state, payload) => {
    state.patientIdentifier = payload;
  }),
  setPatientAddress_1: action((state, payload) => {
    state.patientAddress_1 = payload;
  }),
  setPatientAddress_2: action((state, payload) => {
    state.patientAddress_2 = payload;
  }),
  setPatientCity: action((state, payload) => {
    state.patientCity = payload;
  }),
  setPatientState: action((state, payload) => {
    state.patientState = payload;
  }),
  setPatientPostalCode: action((state, payload) => {
    state.patientPostalCode = payload;
  }),
  setPatientCountry: action((state, payload) => {
    state.patientCountry = payload;
  }),
  setMyAddress_1: action((state, payload) => {
    state.myAddress_1 = payload;
  }),
  setMyAddress_2: action((state, payload) => {
    state.myAddress_2 = payload;
  }),
  setMyCity: action((state, payload) => {
    state.myCity = payload;
  }),
  setMyState: action((state, payload) => {
    state.myState = payload;
  }),
  setMyPostalCode: action((state, payload) => {
    state.myPostalCode = payload;
  }),
  setMyCountry: action((state, payload) => {
    state.myCountry = payload;
  }),
  setDoesTheParticulate: action((state, payload) => {
    state.doesTheParticulate = payload;
  }),
  setPdRenalSelectTheComponent: action((state, payload) => {
    state.pdRenalSelectTheComponent = payload;
  }),
  setShippingDistributionLabelProductCode: action((state, payload) => {
    state.shippingDistributionLabelProductCode = payload;
  }),
  setShippingDistributionLabelProductLot: action((state, payload) => {
    state.shippingDistributionLabelProductLot = payload;
  }),
  setCartonDistributionLabelProductCode: action((state, payload) => {
    state.cartonLabelProductCode = payload;
  }),
  setCartonDistributionLabelProductLot: action((state, payload) => {
    state.cartonLabelProductLot = payload;
  }),
  setInternalProductCode: action((state, payload) => {
    state.internalProductLabelCode = payload;
  }),
  setInternalProductLot: action((state, payload) => {
    state.internalProductLabelLot = payload;
  }),
  setAopDescriptionLabelingIssue: action((state, payload) => {
    state.aopDescriptionLabelingIssue = payload;
  }),
  setAopOptionConnectionIssue: action((state, payload) => {
    state.aopOptionConnectionIssue = payload;
  }),
  setLemCleaningSolutions: action((state, payload) => {
    state.lemCleaningSolutions = payload;
  }),
  setLemDisinfectantNameBrand: action((state, payload) => {
    state.lemDisinfectantNameBrand = payload;
  }),
  setLemExcessiveForce: action((state, payload) => {
    state.lemExcessiveForce = payload;
  }),
  setLemTransferReplaced: action((state, payload) => {
    state.lemtransferReplaced = payload;
  }),
  setLemFollowingOccur: action((state, payload) => {
    state.lemFollowingOccur = payload;
  }),
  setDtuTransfer: action((state, payload) => {
    state.dtuTransfer = payload;
  }),
  setLemTransfer: action((state, payload) => {
    state.lemTransfer = payload;
  }),
  setScTransfer: action((state, payload) => {
    state.scTransfer = payload;
  }),
  setLemTwistClamp: action((state, payload) => {
    state.lemTwistClamp = payload;
  }),
  setLemDifficultInTwistClamp: action((state, payload) => {
    state.lemDifficultInTwistClamp = payload;
  }),
  setLiAppropriateDescription: action((state, payload) => {
    state.liAppropriateDescription = payload;
  }),
  setFiSpecificallyDescribes: action((state, payload) => {
    state.fiSpecificallyDescribes = payload;
  }),
  setSiepLabelingIssue: action((state, payload) => {
    state.siepLabelingIssue = payload;
  }),
  setLiExpiredProduct: action((state, payload) => {
    state.liExpiredProduct = payload;
  }),
  setOthAbnormalitiesDamage: action((state, payload) => {
    state.othAbnormalitiesDamage = payload;
  }),
  setLiExpirationDateProduct: action((state, payload) => {
    state.liExpirationDateProduct = payload;
  }),
  setOthMedicationsSolutions: action((state, payload) => {
    state.othMedicationsSolutions = payload;
  }),
  setSiepAopDescriptionLabelingIssue: action((state, payload) => {
    state.siepAopDescriptionLabelingIssue = payload;
  }),
  setScFollowingScenarios: action((state, payload) => {
    state.scFollowingScenarios = payload;
  }),
  setScBondedComponents: action((state, payload) => {
    state.scBondedComponents = payload;
  }),
  setFiVisibleIrregularitiesObserved: action((state, payload) => {
    state.fiVisibleIrregularitiesObserved = payload;
  }),
  setDamDescOfIssue: action((state, payload) => {
    state.damDescOfIssue = payload;
  }),
  setScWasPowerInjector: action((state, payload) => {
    state.scWasPowerInjector = payload;
  }),
  setDamWasPowerInjector: action((state, payload) => {
    state.damWasPowerInjector = payload;
  }),
  setDisHowProductStored: action((state, payload) => {
    state.disHowProductStored = payload;
  }),
  setAopMaterialDetails: action((state, payload) => {
    state.aopMaterialDetails = payload;
  }),
  setSameAsMyAddressCheck: action((state, payload) => {
    state.sameAsMyAddressCheck = payload;
    if (payload) {
      state.sameAsAddress1 = state.sameAsAddress1 || state.patientAddress_1;
      state.sameAsAddress2 = state.sameAsAddress2 || state.patientAddress_2;
      state.sameAsPhoneNumber = state.sameAsPhoneNumber || state.patientPhoneNumber;
      state.sameAsCity = state.sameAsCity || state.patientCity;
      state.sameAsState = state.sameAsState || state.patientState;
      state.sameAsPostalCode = state.sameAsPostalCode || state.patientPostalCode;
      state.sameAsCountry = state.sameAsCountry || state.patientCountry;
    } else {
      state.sameAsAddress1 = '';
      state.sameAsAddress2 = '';
      state.sameAsPhoneNumber = '';
      state.sameAsCity = '';
      state.sameAsState = '';
      state.sameAsPostalCode = '';
      state.sameAsCountry = '';
    }
  }),
  setSameAsPatientAddressCheck: action((state, payload) => {
    state.sameAsPatientAddressCheck = payload;
    if (payload) {
      state.samePatientAddress_1 = state.samePatientAddress_1 || state.patientAddress_1;
      state.samePatientAddress_2 = state.samePatientAddress_2 || state.patientAddress_2;
      state.samePatientCity = state.samePatientCity || state.patientCity;
      state.samePatientState = state.samePatientState || state.patientState;
      state.samePatientPostalCode = state.samePatientPostalCode || state.patientPostalCode;
      state.samePatientCountry = state.samePatientCountry || state.patientCountry;
    } else {
      state.samePatientAddress_1 = '';
      state.samePatientAddress_2 = '';
      state.samePatientCity = '';
      state.samePatientState = '';
      state.samePatientPostalCode = '';
      state.samePatientCountry = '';
    }
  }),
  setSiexAccessOrderedFromBaxter: action((state, payload) => {
    state.siexAccessOrderedFromBaxter = payload;
  }),
  setLiOrderedFromBaxter: action((state, payload) => {
    state.liOrderedFromBaxter = payload;
  }),
  setPdrComponentHadIssue: action((state, payload) => {
    state.pdrComponentHadIssue = payload;
  }),
  setTsetLemTransferReplaced: action((state, payload) => {
    state.tsetLemtransferReplaced = payload;
  }),
  setAopPurchaseOrderNumber: action((state, payload) => {
    state.aopPurchaseOrderNumber = payload;
  }),
  setAopSolutionOrderedFromBaxter: action((state, payload) => {
    state.aopSolutionOrderedFromBaxter = payload;
  }),
  setErrorOnNext: action((state, payload) => {
    state.errorOnNext = payload;
  }),
  setPatientDob: action((state, payload) => {
    state.patientDob = payload;
    if (payload === 'decline') {
      state.patientAge = '';
    }
  }),
  setScIssueResultLeak: action((state, payload) => {
    state.scIssueResultLeak = payload;
  }),
  setLemAnyComponentDamaged: action((state, payload) => {
    state.lemAnyComponentDamaged = payload;
  }),
  setLemComponentHadIssue: action((state, payload) => {
    state.lemComponentHadIssue = payload;
  }),
  setDtuCleaningSolutions: action((state, payload) => {
    state.dtuCleaningSolutions = payload;
  }),
  setScCleaningSolutions: action((state, payload) => {
    state.scCleaningSolutions = payload;
  }),
  setAccAppropriateDescIssue: action((state, payload) => {
    state.accAppropriateDescIssue = payload;
  }),
  setAccSolutionOrderedFromBaxter: action((state, payload) => {
    state.accSolutionOrderedFromBaxter = payload;
  }),
  setDamComponentHadIssue: action((state, payload) => {
    state.damComponentHadIssue = payload;
  }),
  setSolutionFlowIssueObservedDamage: action((state, payload) => {
    state.solutionFlowIssueobservedDamage = payload;
  }),
  setSolutionFlowIssueTypeObservedDamage: action((state, payload) => {
    state.solutionFlowIssueTypeObservedDamage = payload;
  }),
  setSolutionFlowIssueDamageCauseLeak: action((state, payload) => {
    state.solutionFlowIssueDamageCauseLeak = payload;
  }),
  setSolutionOtherObservedDamage: action((state, payload) => {
    state.solutionOtherobservedDamage = payload;
  }),
  setSolutionOtherTypeObservedDamage: action((state, payload) => {
    state.solutionOtherTypeObservedDamage = payload;
  }),
  setSolutionOtherDamageCauseLeak: action((state, payload) => {
    state.solutionOtherDamageCauseLeak = payload;
  }),
  setSiepLeakObservedDamage: action((state, payload) => {
    state.siepLeakObservedDamage = payload;
  }),
  setErrorForUncompleteForm: action((state, payload) => {
    state.errorForUncompleteForm = payload;
  }),
  setAcSpecificallyDeviceAlarm: action((state, payload) => {
    state.acSpecificallyDeviceAlarm = payload;
  }),
  setSiepYourDistributor: action((state, payload) => {
    state.siepYourDistributor = payload;
  }),
  setSolPurchaseOrderNumber: action((state, payload) => {
    state.solPurchaseOrderNumber = payload;
  }),
  setScDisinfectantNameBrand: action((state, payload) => {
    state.scDisinfectantNameBrand = payload;
  }),
  setDtuDisinfectantNameBrand: action((state, payload) => {
    state.dtuDisinfectantNameBrand = payload;
  }),
  setAopMaterialLocated: action((state, payload) => {
    state.aopMaterialLocated = payload;
  }),
  setScPdrDamageCutHoleCrack: action((state, payload) => {
    state.scPdrDamageCutHoleCrack = payload;
  }),
  setScFullyTightened: action((state, payload) => {
    state.scFullyTightened = payload;
  }),
  setScProductInfoDisconnection: action((state, payload) => {
    state.scProductInfoDisconnection = payload;
  }),
  setLemProductInfoDisconnection: action((state, payload) => {
    state.lemProductInfoDisconnection = payload;
  }),
  setScAccessProductInfoDisconnection: action((state, payload) => {
    state.scAccessProductInfoDisconnection = payload;
  }),
  setSiepCarrierDelivered: action((state, payload) => {
    state.siepCarrierDelivered = payload;
  }),
  setAopExpiredProductFound: action((state, payload) => {
    state.aopExpiredProductFound = payload;
  }),
  setSubmitApiResponse: action((state, payload) => {
    state.submitApiResponse = payload;
  }),
  setDoeError: action((state, payload) => {
    state.doeError = payload;
  }),
  setUpdatedEventDate: action((state, payload) => {
    state.updatedEventDate = payload;
  }),
  setHardware: action((state, payload) => {
    state.hardware = payload;
  }),
  setSamePatientAddress_1: action((state, payload) => {
    state.samePatientAddress_1 = payload;
  }),
  setSamePatientAddress_2: action((state, payload) => {
    state.samePatientAddress_2 = payload;
  }),
  setSamePatientCity: action((state, payload) => {
    state.samePatientCity = payload;
  }),
  setSamePatientState: action((state, payload) => {
    state.samePatientState = payload;
  }),
  setSamePatientPostalCode: action((state, payload) => {
    state.samePatientPostalCode = payload;
  }),
  setSamePatientCountry: action((state, payload) => {
    state.samePatientCountry = payload;
  }),
  setOtherLemComponentHadIssue: action((state, payload) => {
    state.otherLemComponentHadIssue = payload;
  }),
  setOtherDamComponentHadIssue: action((state, payload) => {
    state.otherDamComponentHadIssue = payload;
  }),
  setOtherSelectComponentHadIssue: action((state, payload) => {
    state.otherSelectComponentHadIssue = payload;
  }),
  setOtherPdrComponentHadIssue: action((state, payload) => {
    state.otherPdrComponentHadIssue = payload;
  }),
  setOtherComponentHadIssue: action((state, payload) => {
    state.otherComponentHadIssue = payload;
  }),
  setOtherDifficultToUse: action((state, payload) => {
    state.otherDifficultToUse = payload;
  }),
  setOtherDifficultiesMinicap: action((state, payload) => {
    state.otherDifficultiesMinicap = payload;
  }),
  setOtherBlockingFlow: action((state, payload) => {
    state.otherBlockingFlow = payload;
  }),
  setOtherDescribeIssue: action((state, payload) => {
    state.otherDescribeIssue = payload;
  }),
  setOtherMaterialLocated: action((state, payload) => {
    state.otherMaterialLocated = payload;
  }),
  setOtherObservedDamage: action((state, payload) => {
    state.otherObservedDamage = payload;
  }),
  setOtherTypeObservedDamage: action((state, payload) => {
    state.otherTypeObservedDamage = payload;
  }),
  setOtherAppropriateDescription: action((state, payload) => {
    state.otherAppropriateDescription = payload;
  }),
  setOtherLiAppropriateDescription: action((state, payload) => {
    state.otherLiAppropriateDescription = payload;
  }),
  setOtherProductDiscolored: action((state, payload) => {
    state.otherProductDiscolored = payload;
  }),
  setOtherSpecificallyDescribes: action((state, payload) => {
    state.otherSpecificallyDescribes = payload;
  }),
  setOtherMatterForeignMaterial: action((state, payload) => {
    state.otherMatterForeignMaterial = payload;
  }),
  setOtherMatterForeignMaterialPieces: action((state, payload) => {
    state.otherMatterForeignMaterialPieces = payload;
  }),
  setOtherDamageIssueObserved: action((state, payload) => {
    state.otherDamageIssueObserved = payload;
  }),
  setOtherProductThawed: action((state, payload) => {
    state.otherProductThawed = payload;
  }),
  setOtherDamageSpecificInfo: action((state, payload) => {
    state.otherDamageSpecificInfo = payload;
  }),
  setOtherLabelingIssue: action((state, payload) => {
    state.otherLabelingIssue = payload;
  }),
  setOtherWhatIncorrectlyDisplayed: action((state, payload) => {
    state.otherWhatIncorrectlyDisplayed = payload;
  }),
  setOtherMoistureObserved: action((state, payload) => {
    state.otherMoistureObserved = payload;
  }),
  setOtherComponentLeaking: action((state, payload) => {
    state.otherComponentLeaking = payload;
  }),
  setOtherDamageComponentAffected: action((state, payload) => {
    state.otherDamageComponentAffected = payload;
  }),
  setOtherWhatTypeDamageIssue: action((state, payload) => {
    state.otherWhatTypeDamageIssue = payload;
  }),
  setOtherIssueResultLeak: action((state, payload) => {
    state.otherIssueResultLeak = payload;
  }),
  setOtherSituationDescribesIssue: action((state, payload) => {
    state.otherSituationDescribesIssue = payload;
  }),
  setOtherDescriptionLabelingIssue: action((state, payload) => {
    state.otherDescriptionLabelingIssue = payload;
  }),
  setOtherAopDescriptionLabelingIssue: action((state, payload) => {
    state.otherAopDescriptionLabelingIssue = payload;
  }),
  setOtherSiepAopDescriptionLabelingIssue: action((state, payload) => {
    state.otherSiepAopDescriptionLabelingIssue = payload;
  }),
  setOtherAccAppropriateDescIssue: action((state, payload) => {
    state.otherAccAppropriateDescIssue = payload;
  }),
  setOtherLeakComingFrom: action((state, payload) => {
    state.otherLeakComingFrom = payload;
  }),
  setOtherFollowingScenarios: action((state, payload) => {
    state.otherFollowingScenarios = payload;
  }),
  setOtherInjectionSiteOpening: action((state, payload) => {
    state.otherInjectionSiteOpening = payload;
  }),
  setOtherScIssueResultLeak: action((state, payload) => {
    state.otherScIssueResultLeak = payload;
  }),
  setOtherSituationFlowIssue: action((state, payload) => {
    state.otherSituationFlowIssue = payload;
  }),
  setOtherSituationsApplyEvent: action((state, payload) => {
    state.otherSituationsApplyEvent = payload;
  }),
  setOtherSimultaneousFlow: action((state, payload) => {
    state.otherSimultaneousFlow = payload;
  }),
  setOtherWhatClampFailed: action((state, payload) => {
    state.otherWhatClampFailed = payload;
  }),
  setOtherIssuesObservedClamp: action((state, payload) => {
    state.otherIssuesObservedClamp = payload;
  }),
  setOtherOtherSituationsProduct: action((state, payload) => {
    state.otherOtherSituationsProduct = payload;
  }),
  setOtherWhichClampIssue: action((state, payload) => {
    state.otherWhichClampIssue = payload;
  }),
  setOtherClampIssueExperienced: action((state, payload) => {
    state.otherClampIssueExperienced = payload;
  }),
  setOtherClampDescribesIssue: action((state, payload) => {
    state.otherClampDescribesIssue = payload;
  }),
  setOtherLeakOccur: action((state, payload) => {
    state.otherLeakOccur = payload;
  }),
  setOtherProductDamaged: action((state, payload) => {
    state.otherProductDamaged = payload;
  }),
  setOtherOptionFlowIssue: action((state, payload) => {
    state.otherOptionFlowIssue = payload;
  }),
  setOtherDescOfIssue: action((state, payload) => {
    state.otherDescOfIssue = payload;
  }),
  setOtherDamDescOfIssue: action((state, payload) => {
    state.otherDamDescOfIssue = payload;
  }),
  setOtherResidueThreads: action((state, payload) => {
    state.otherResidueThreads = payload;
  }),
  setOtherAnyComponentDamaged: action((state, payload) => {
    state.otherAnyComponentDamaged = payload;
  }),
  setOtherMoistureClear: action((state, payload) => {
    state.otherMoistureClear = payload;
  }),
  setOtherInfusateSolution: action((state, payload) => {
    state.otherInfusateSolution = payload;
  }),
  setDrugsAndBiologics: action((state, payload) => {
    state.drugsAndBiologics = payload;
  }),
  setScDamageCutHoleCrack: action((state, payload) => {
    state.scDamageCutHoleCrack = payload;
  }),
  setOtherSolutionFlowIssueobservedDamage: action((state, payload) => {
    state.otherSolutionFlowIssueobservedDamage = payload;
  }),
  setOtherSolutionOtherobservedDamage: action((state, payload) => {
    state.otherSolutionOtherobservedDamage = payload;
  }),
  setOtherSolutionOtherTypeObservedDamage: action((state, payload) => {
    state.otherSolutionOtherTypeObservedDamage = payload;
  }),
  setOtherSolutionFlowIssueTypeObservedDamage: action((state, payload) => {
    state.otherSolutionFlowIssueTypeObservedDamage = payload;
  }),
  setLotResetFlag: action((state, payload) => {
    state.lotResetFlag = payload;
  }),
  setPcodeResetFlag: action((state, payload) => {
    state.pcodeResetFlag = payload;
  }),
  setNdcResetFlag: action((state, payload) => {
    state.ndcResetFlag = payload;
  }),
  setUdiResetFlag: action((state, payload) => {
    state.udcResetFlag = payload;
  }),
  setPnameResetFlag: action((state, payload) => {
    state.pnameResetFlag = payload;
  }),
  setAcWhatAlarm: action((state, payload) => {
    state.acWhatAlarm = payload;
  }),
  setIntakeFieldResetFlag: action((state, payload) => {
    state.intakeFieldResetFlag = payload;
  }),
  setOtherFiSpecificallyDescribes: action((state, payload) => {
    state.otherFiSpecificallyDescribes = payload;
  }),
  setOtherSiepLabelingIssue: action((state, payload) => {
    state.otherSiepLabelingIssue = payload;
  }),
  setOtherScFollowingScenarios: action((state, payload) => {
    state.otherScFollowingScenarios = payload;
  }),
  setOtherVisibleIrregularities: action((state, payload) => {
    state.otherVisibleIrregularities = payload;
  }),
  setOtherAlarm: action((state, payload) => {
    state.otherAlarm = payload;
  }),
  setOtherToolUsedAssist: action((state, payload) => {
    state.otherToolUsedAssist = payload;
  }),
  setOtherDescribesDiscoloration: action((state, payload) => {
    state.otherDescribesDiscoloration = payload;
  }),
  setOtherWhatComponentDiscolored: action((state, payload) => {
    state.otherWhatComponentDiscolored = payload;
  }),
  setOtherWithPump: action((state, payload) => {
    state.otherWithPump = payload;
  }),
  setRedirectPatientPhoneNumber: action((state, payload) => {
    state.patientPhoneNumber = payload;
    state.redirectPatientPhoneNumber = payload;
    state.redirectPatientPhoneNumberFlag = false;
  }),
  setRedirectPatientEmail: action((state, payload) => {
    state.patientEmail = payload;
    state.redirectPatientEmail = payload;
    state.redirectPatientEmailFlag = false;
  }),
  setRedirectPatientAge: action((state, payload) => {
    state.patientAge = payload;
    state.redirectPatientAge = payload;
  }),
  setRedirectedFromPortalFlag: action((state, payload) => {
    state.redirectedFromPortalFlag = payload;
  }),
  setIsUserLoggedIn: action((state, payload) => {
    state.isUserLoggedIn = payload;
  }),
  fetchUserInfo: thunk((actions, payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        const accessToken = payload.accessToken;
        const idToken = payload.idToken;        
        if (accessToken && idToken) {
          let oktaUserDtl:any = {};
          const oktaUserInfo = new OktaSignIn(OktaConfig.widget);
          await oktaUserInfo.authClient.token.getUserInfo(accessToken, idToken).then(function (user) {
            oktaUserDtl = user;
          });
          
          const firstname = oktaUserDtl?.given_name;
          const lastname = oktaUserDtl?.family_name;
          const email = oktaUserDtl?.email;
          const phone = oktaUserDtl?.phone_number;

          actions.setIsUserLoggedIn(true);
          actions.setEmployeeEmail(email);
          actions.setEmployeePhone(phone);
          actions.setEmployeeFirstName(firstname);
          actions.setEmployeeLastName(lastname);

          resolve(true);
        } else {
          resolve(false);
        }
      } catch (error) {
        resolve(false);
      }
    });
  }),
  setRedirectAccountNumber: action((state, payload) => {
    state.accountNumber = payload;
    state.redirectAccountNumber = payload;
  }),
  setYourFirstName: action((state, payload) => {
    state.yourFirstName = payload;
  }),
  setYourLastName: action((state, payload) => {
    state.yourLastName = payload;
  }),
  setMyFirstName: action((state, payload) => {
    state.myFirstName = payload;
  }),
  setMyLastName: action((state, payload) => {
    state.myLastName = payload;
  }),
  setPatientFirstName: action((state, payload) => {
    state.patientFirstName = payload;
  }),
  setPatientLastName: action((state, payload) => {
    state.patientLastName = payload;
  }),
  setReporterFirstName: action((state, payload) => {
    state.reporterFirstName = payload;
  }),
  setReporterLastName: action((state, payload) => {
    state.reporterLastName = payload;
  }),
  setEmployeeFirstName: action((state, payload) => {
    state.employeeFirstName = payload;
  }),
  setEmployeeLastName: action((state, payload) => {
    state.employeeLastName = payload;
  }),
  setEndUserCostomerContactFirstName: action((state, payload) => {
    state.endUserCostomerContactFirstName = payload;
  }),
  setEndUserCostomerContactLastName: action((state, payload) => {
    state.endUserCostomerContactLastName = payload;
  }),
  setAdditionalContactFirstName: action((state, payload) => {
    state.additionalContactFirstName = payload;
  }),
  setAdditionalContactLastName: action((state, payload) => {
    state.additionalContactLastName = payload;
  }),
  setPQFieldResetFlag: action((state, payload) => {
    state.pqFieldResetFlag = payload;
  }),
  setProductCodeResetFlag: action((state, payload) => {
    state.productCodeResetFlag = payload;
  }),
  setWhatMedicationSolution: action((state, payload) => {
    state.whatMedicationSolution = payload;
  }),
  setAdditionalContact: action((state, payload) => {
    state.addAdditionalContact = payload;
  }),
  setCustomerDoesNotWish: action((state, payload) => {
    state.customerDoesNotWish = payload;
  }),
  setMyAddressDoNotContact: action((state, payload) => {
    state.myAddressDoNotContact = payload;
  }),
  setFacilityAddressDoNotContact: action((state, payload) => {
    state.facilityAddressDoNotContact = payload;
  }),
  setEndUserCustomerFacilityName: action((state, payload) => {
    state.endUserCustomerFacilityName = payload;
  }),
  setEndUserCustomerFacilityPhone: action((state, payload) => {
    state.endUserCustomerFacilityPhone = payload;
  }),
  setEndUserCustomerEmail: action((state, payload) => {
    state.endUserCustomerEmail = payload;
  }),
  setEndUserCustomerFacilityAddress1: action((state, payload) => {
    state.endUserCustomerFacilityAddress1 = payload;
  }),
  setEndUserCustomerFacilityAddress2: action((state, payload) => {
    state.endUserCustomerFacilityAddress2 = payload;
  }),
  setEndUserCustomerFacilityCity: action((state, payload) => {
    state.endUserCustomerFacilityCity = payload;
  }),
  setEndUserCustomerFacilityState: action((state, payload) => {
    state.endUserCustomerFacilityState = payload;
  }),
  setEndUserCustomerFacilityPostalCode: action((state, payload) => {
    state.endUserCustomerFacilityPostalCode = payload;
  }),
  setEndUserCustomerFacilityCountry: action((state, payload) => {
    state.endUserCustomerFacilityCountry = payload;
  }),
  setPatientAddressDoNotContact: action((state, payload) => {
    state.patientAddressDoNotContact = payload;
  }),
  setMyAddressSameAsPatientAddressCheck: action((state, payload) => {
    state.myAddressSameAsPatientAddressCheck = payload;
    if (payload) {
      state.myAddress_1 = state.samePatientAddress_1;
      state.myAddress_2 = state.samePatientAddress_2;
      state.myCity = state.samePatientCity;
      state.myState = state.samePatientState;
      state.myPostalCode = state.samePatientPostalCode;
      state.myCountry = state.samePatientCountry;
    } else {
      state.myAddress_1 = '';
      state.myAddress_2 = '';
      state.myCity = '';
      state.myState = '';
      state.myPostalCode = '';
      state.myCountry = '';
    }
  }),
  setReturnKitAddressSameAsMyAddress: action((state, payload) => {
    state.returnKitAddressSameAsMyAddress = payload;
    if (payload && (state.role === ROLE_PROFESSIONAL || state.role === ROLE_DISTRIBUTOR || state.role === ROLE_OTHER)) {
      state.sameAsAddress1 = state.sameAsAddress1 || state.facilityAddress1;
      state.sameAsAddress2 = state.sameAsAddress2 || state.facilityAddress2;
      state.sameAsCity = state.sameAsCity || state.facilityCity;
      state.sameAsState = state.sameAsState || state.facilityState;
      state.sameAsPostalCode = state.sameAsPostalCode || state.facilityPostalCode;
      state.sameAsCountry = state.sameAsCountry || state.facilityCountry;
      state.sameAsPhoneNumber = state.sameAsPhoneNumber || state.phoneNumber;
    }
    else if (payload && (state.role === ROLE_CAREGIVER)) {
      state.sameAsAddress1 = state.sameAsAddress1 || state.myAddress_1;
      state.sameAsAddress2 = state.sameAsAddress2 || state.myAddress_2;
      state.sameAsCity = state.sameAsCity || state.myCity;
      state.sameAsState = state.sameAsState || state.myState;
      state.sameAsPostalCode = state.sameAsPostalCode || state.myPostalCode;
      state.sameAsCountry = state.sameAsCountry || state.myCountry;
      state.sameAsPhoneNumber = state.sameAsPhoneNumber || state.myPhoneNumber;
    }
    else {
      state.sameAsAddress1 = '';
      state.sameAsAddress2 = '';
      state.sameAsPhoneNumber = '';
      state.sameAsCity = '';
      state.sameAsState = '';
      state.sameAsPostalCode = '';
      state.sameAsCountry = '';
    }

  }),
  setReturnKitAddressSameAsReporterAddress: action((state, payload) => {
    state.returnKitAddressSameAsReporterAddress = payload;

    if (payload) {
      state.sameAsAddress1 = state.sameAsAddress1 || state.reporterAddress1;
      state.sameAsAddress2 = state.sameAsAddress2 || state.reporterAddress2;
      state.sameAsPhoneNumber = state.sameAsPhoneNumber || state.reporterPhone;
      state.sameAsCity = state.sameAsCity || state.reporterCity;
      state.sameAsState = state.sameAsState || state.reporterState;
      state.sameAsPostalCode = state.sameAsPostalCode || state.reporterPostalCode;
      state.sameAsCountry = state.sameAsCountry || state.reporterCountry;
    } else {
      state.sameAsAddress1 = '';
      state.sameAsAddress2 = '';
      state.sameAsPhoneNumber = '';
      state.sameAsCity = '';
      state.sameAsState = '';
      state.sameAsPostalCode = '';
      state.sameAsCountry = '';
    }

  }),
  setReturnKitAddressSameAsPatientAddress: action((state, payload) => {
    state.returnKitAddressSameAsPatientAddress = payload;

    if (payload) {
      state.sameAsAddress1 = state.sameAsAddress1 || state.samePatientAddress_1;
      state.sameAsAddress2 = state.sameAsAddress2 || state.samePatientAddress_2;
      state.sameAsCity = state.sameAsCity || state.samePatientCity;
      state.sameAsState = state.sameAsState || state.samePatientState;
      state.sameAsPostalCode = state.sameAsPostalCode || state.samePatientPostalCode;
      state.sameAsCountry = state.sameAsCountry || state.samePatientCountry;
      state.sameAsPhoneNumber = state.sameAsPhoneNumber || state.patientPhoneNumber;
    } else {
      state.sameAsAddress1 = '';
      state.sameAsAddress2 = '';
      state.sameAsPhoneNumber = '';
      state.sameAsCity = '';
      state.sameAsState = '';
      state.sameAsPostalCode = '';
      state.sameAsCountry = '';
    }
  }),
  setReturnKitAddressSameAsEndUserCustomerAddress: action((state, payload) => {
    state.returnKitAddressSameAsEndUserCustomerAddress = payload;

    if (payload) {
      state.sameAsAddress1 = state.sameAsAddress1 || state.endUserCustomerFacilityAddress1;
      state.sameAsAddress2 = state.sameAsAddress2 || state.endUserCustomerFacilityAddress2;
      state.sameAsCity = state.sameAsCity || state.endUserCustomerFacilityCity;
      state.sameAsState = state.sameAsState || state.endUserCustomerFacilityState;
      state.sameAsPostalCode = state.sameAsPostalCode || state.endUserCustomerFacilityPostalCode;
      state.sameAsCountry = state.sameAsCountry || state.endUserCustomerFacilityCountry;
      state.sameAsPhoneNumber = state.sameAsPhoneNumber || state.endUserCustomerFacilityPhone;
    } else {
      state.sameAsAddress1 = '';
      state.sameAsAddress2 = '';
      state.sameAsPhoneNumber = '';
      state.sameAsCity = '';
      state.sameAsState = '';
      state.sameAsPostalCode = '';
      state.sameAsCountry = '';
    }
  }),
  setRedirectedFromB2bPortal: action((state, payload) => {
    state.redirectedFromB2bPortal = payload;
  }),
  setUncompleteAddressInProduct: action((state, payload) => {
    state.uncompleteAddressInProduct = payload;
  }),
  setIsReturnKitAddressAdded: action((state, payload) => {
    state.isReturnKitAddressAdded = payload;
  }),
};

export default formModel;
